package com.swetdot.swetgram.ui.chat

import androidx.compose.animation.Crossfade
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.animate
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.gestures.Orientation
import androidx.compose.foundation.gestures.draggable
import androidx.compose.foundation.gestures.rememberDraggableState
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import com.swetdot.swetgram.ui.design.SwetBasicTextField
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.LayoutCoordinates
import androidx.compose.ui.layout.boundsInWindow
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.semantics.LiveRegionMode
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.liveRegion
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntRect
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.swetdot.swetgram.domain.Chat
import com.swetdot.swetgram.domain.ChatId
import com.swetdot.swetgram.domain.ChatKind
import com.swetdot.swetgram.domain.LocalDay
import com.swetdot.swetgram.domain.Message
import com.swetdot.swetgram.domain.MessageId
import com.swetdot.swetgram.domain.MessageKind
import com.swetdot.swetgram.domain.MessageState
import com.swetdot.swetgram.domain.SquadStreakDomain
import com.swetdot.swetgram.domain.TimelineItem
import com.swetdot.swetgram.domain.User
import com.swetdot.swetgram.domain.UserId
import com.swetdot.swetgram.data.media.VoicePlaybackState
import com.swetdot.swetgram.domain.buildTimeline
import com.swetdot.swetgram.ui.design.Radius
import com.swetdot.swetgram.ui.design.Motion
import com.swetdot.swetgram.ui.design.Sizes
import com.swetdot.swetgram.ui.design.Space
import com.swetdot.swetgram.ui.design.SwetAvatar
import com.swetdot.swetgram.ui.design.SwetEmptyState
import com.swetdot.swetgram.ui.design.SwetErrorBanner
import com.swetdot.swetgram.ui.design.SwetIcon
import com.swetdot.swetgram.ui.design.SwetEasing
import com.swetdot.swetgram.ui.design.SwetIconButton
import com.swetdot.swetgram.ui.design.SwetIcons
import com.swetdot.swetgram.ui.design.SwetPressFeedback
import com.swetdot.swetgram.ui.design.SwetPullToRefresh
import com.swetdot.swetgram.ui.design.SwetSecondaryButton
import com.swetdot.swetgram.ui.design.SwetSendButton
import com.swetdot.swetgram.ui.design.SwetTextButton
import com.swetdot.swetgram.ui.design.SwetTopAppBar
import com.swetdot.swetgram.ui.design.SwetBlackBadge
import com.swetdot.swetgram.ui.design.TouchTarget
import com.swetdot.swetgram.ui.design.reduceMotion
import com.swetdot.swetgram.ui.design.singleLinePreview
import com.swetdot.swetgram.ui.design.swetAnimateMessageItem
import com.swetdot.swetgram.ui.design.swetTween
import com.swetdot.swetgram.ui.design.swetPressable
import com.swetdot.swetgram.ui.design.swetTransitionTarget
import com.swetdot.swetgram.data.moderation.ReportTarget
import com.swetdot.swetgram.ui.groups.memberCountLine
import com.swetdot.swetgram.ui.moderation.ReportRequest
import com.swetdot.swetgram.ui.moderation.ReportedAccount
import com.swetdot.swetgram.ui.text.UiText
import com.swetdot.swetgram.ui.text.count
import com.swetdot.swetgram.ui.text.resolve
import com.swetdot.swetgram.ui.text.resolveOrNull
import com.swetdot.swetgram.ui.text.text
import com.swetdot.swetgram.ui.theme.SwetgramThemeTokens
import kotlinx.datetime.TimeZone
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource
import swetgram.shared.generated.resources.Res
import swetgram.shared.generated.resources.chat_action_cancel
import swetgram.shared.generated.resources.chat_action_close
import swetgram.shared.generated.resources.chat_action_copy
import swetgram.shared.generated.resources.chat_action_delete
import swetgram.shared.generated.resources.chat_action_edit
import swetgram.shared.generated.resources.chat_action_forward
import swetgram.shared.generated.resources.chat_action_keep
import swetgram.shared.generated.resources.chat_action_pin
import swetgram.shared.generated.resources.chat_action_reply
import swetgram.shared.generated.resources.chat_action_report
import swetgram.shared.generated.resources.chat_action_retry
import swetgram.shared.generated.resources.chat_action_select
import swetgram.shared.generated.resources.chat_action_unpin
import swetgram.shared.generated.resources.chat_attach_image
import swetgram.shared.generated.resources.chat_back
import swetgram.shared.generated.resources.chat_composer_placeholder_plain
import swetgram.shared.generated.resources.chat_composer_placeholder_titled
import swetgram.shared.generated.resources.chat_composer_placeholder_user
import swetgram.shared.generated.resources.chat_delete_confirm_everyone
import swetgram.shared.generated.resources.chat_delete_confirm_self
import swetgram.shared.generated.resources.chat_delete_confirm_unsent
import swetgram.shared.generated.resources.chat_delete_for_everyone
import swetgram.shared.generated.resources.chat_delete_for_me
import swetgram.shared.generated.resources.chat_delete_selected_confirm
import swetgram.shared.generated.resources.chat_edit_save
import swetgram.shared.generated.resources.chat_editing_message
import swetgram.shared.generated.resources.chat_empty_body
import swetgram.shared.generated.resources.chat_empty_title
import swetgram.shared.generated.resources.chat_message_options
import swetgram.shared.generated.resources.chat_message_react
import swetgram.shared.generated.resources.chat_selected_count
import swetgram.shared.generated.resources.chat_selection_close
import swetgram.shared.generated.resources.chat_selection_toggle
import swetgram.shared.generated.resources.chat_forward_empty
import swetgram.shared.generated.resources.chat_forward_search
import swetgram.shared.generated.resources.chat_forward_title
import swetgram.shared.generated.resources.chat_photo_open
import swetgram.shared.generated.resources.chat_open_profile
import swetgram.shared.generated.resources.chat_pinned_count
import swetgram.shared.generated.resources.chat_pinned_heading
import swetgram.shared.generated.resources.chat_pinned_open
import swetgram.shared.generated.resources.chat_presence_last_seen_date
import swetgram.shared.generated.resources.chat_presence_last_seen_today
import swetgram.shared.generated.resources.chat_presence_last_seen_yesterday
import swetgram.shared.generated.resources.chat_presence_online
import swetgram.shared.generated.resources.chat_preview_body_deleted
import swetgram.shared.generated.resources.chat_preview_body_none
import swetgram.shared.generated.resources.chat_preview_body_photo
import swetgram.shared.generated.resources.chat_preview_from
import swetgram.shared.generated.resources.chat_preview_own
import swetgram.shared.generated.resources.chat_preview_own_title
import swetgram.shared.generated.resources.chat_refresh
import swetgram.shared.generated.resources.chat_refreshing
import swetgram.shared.generated.resources.chat_send
import swetgram.shared.generated.resources.chat_voice_cancel
import swetgram.shared.generated.resources.chat_voice_delete
import swetgram.shared.generated.resources.chat_voice_lock
import swetgram.shared.generated.resources.chat_voice_message
import swetgram.shared.generated.resources.picso_shared_message
import swetgram.shared.generated.resources.chat_voice_pause
import swetgram.shared.generated.resources.chat_voice_record
import swetgram.shared.generated.resources.chat_voice_recording
import swetgram.shared.generated.resources.chat_voice_retry
import swetgram.shared.generated.resources.chat_voice_resume
import swetgram.shared.generated.resources.chat_voice_send
import swetgram.shared.generated.resources.chat_voice_slide_cancel
import swetgram.shared.generated.resources.chat_voice_slide_lock
import swetgram.shared.generated.resources.chat_voice_uploading
import swetgram.shared.generated.resources.chat_send_failed_note
import swetgram.shared.generated.resources.chat_send_failed_note_retryable
import swetgram.shared.generated.resources.handle_prefixed
import swetgram.shared.generated.resources.value_passthrough
import kotlin.time.Clock
import kotlin.time.Instant

/** DECISIONS §5 and SDS §12.4: text messages are capped at 4096 characters. */
const val MAX_MESSAGE_LENGTH = 4096

/**
 * How far from the bottom the reader may be and still be carried to a newly arrived message.
 *
 * TWO rows rather than zero, because the check happens AFTER the list has already taken the new
 * item: a reader parked at the bottom is at index 1 by then, or at index 2 when the message opened
 * a new day and brought a separator with it. Larger than that and it would start yanking somebody
 * who had deliberately scrolled up a little.
 */
private const val FOLLOW_SLOP_ROWS = 2
private const val MAX_ANIMATED_FOLLOW_ROWS = 6

/**
 * How close to the top of the loaded history the reader may get before the next page is asked for.
 *
 * Far enough ahead that the page is usually already in the cache by the time they reach it, near
 * enough that opening a conversation does not immediately request history nobody asked to see --
 * the first screenful is well under a page, so this never fires on open.
 */
private const val LOAD_OLDER_SLOP_ROWS = 5

/**
 * A row's stable identity, used both as the LazyColumn key and as the signal that the bottom of
 * the conversation changed.
 *
 * One function rather than two copies of the same `when`: the follow-the-bottom effect is only
 * correct if it keys off exactly the identity the list itself uses, and two expressions that must
 * agree are two expressions that will eventually not.
 */
private fun TimelineItem.rowKey(): String = when (this) {
    is TimelineItem.MessageRow -> "m:${message.clientId}"
    is TimelineItem.DaySeparator -> "d:$day"
}

/**
 * One conversation.
 *
 * THIS SCREEN IS BUILT TO A USER-SUPPLIED MOCKUP THAT OVERRIDES THE DESIGN SYSTEM IN FIVE PLACES,
 * recorded in DECISIONS.md §25 and at the tokens themselves in `ChatColors`:
 *
 *  - SDS §12.4 puts own messages on `accent.blue` with white text. They are near-white with dark
 *    text, and the incoming bubble is the same `card` grey it always was.
 *  - SDS §5.3's type scale stops at `caption` 12sp. The bubble metadata -- the timestamp, "edited"
 *    and the delivery tick -- is 10sp, an ELEVENTH role added below the bottom of the scale
 *    (`ui/theme/Type.kt`'s `SwetgramCaptionSmall`), with the tick shrunk to match it.
 *  - SDS §4.3 makes `#000000` "deepest background only" and `#0B0B0B` the app background. The whole
 *    conversation, header and composer included, is on `background.deep`. The strip behind the
 *    STATUS BAR belongs to the app frame rather than to this file -- `ui/Navigation.kt` paints the
 *    canvas there on this route so that "edge to edge" is true rather than nearly true.
 *  - SDS §5.4 puts message text at 17sp and `ui/theme/Type.kt` calls that the readability floor for
 *    chat. It is `bodyMedium` 16sp here, the top of the mockup's stated 15-16sp, and the composer's
 *    input moved with it.
 *  - The read tick was `accent.blue`. The mockup draws it grey, like the timestamp beside it, and
 *    nothing is lost: there is no DELIVERED state, so one check against two is what says it.
 *
 * ONE OVERRIDE CAME OFF THIS LIST. §12.4 also puts the timestamp INSIDE the bubble, bottom right,
 * and this screen shipped it on the canvas beside the bubble -- the mockup's incoming row read that
 * way and the own row was ambiguous, so the symmetric reading was taken and flagged. The user has
 * since looked at it on a phone and said plainly: inside, both directions, trailing the text. So the
 * screen agrees with §12.4 again on that point, the switch that used to choose is deleted rather
 * than pinned to one answer, and the list above is still five long only because the 10sp metadata
 * role took its place.
 *
 * The SDS is a reference document this repository does not own and is NOT edited to agree.
 *
 * The failure banner is the design system's [SwetErrorBanner]. The HEADER is not [SwetTopAppBar]
 * any more -- see [ChatHeader] for why the peer's avatar cannot live in that component's slots --
 * and the composer never was: SDS §12.3's input area is none of the shared components, since
 * [com.swetdot.swetgram.ui.design.SwetTextField] is a 52dp bordered form field with a
 * supporting-text slot, which is the wrong object at the bottom of a chat.
 *
 * Tapping the identity block opens the other person's profile, which is the gesture every messenger
 * trains its users to expect, and the ⓘ in the header does the same thing with a name a screen
 * reader can find. The back button keeps its own tap.
 */
@Composable
fun ChatScreen(
    title: String,
    subtitle: String?,
    members: List<User> = emptyList(),
    messagesNewestFirst: List<Message>,
    me: UserId,
    onSend: (String) -> Unit,
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    /**
     * The conversation-level failure, as a CHOSEN message rather than a rendered one.
     *
     * A `UiText` because the sentence is picked by `ChatViewModel.chatBannerMessage`, which is a
     * pure rule with no composition to resolve a resource in -- see `ui/text/UiText.kt`. This
     * screen resolves it, which is also the only place that can.
     */
    error: UiText? = null,
    onRetry: (() -> Unit)? = null,
    /**
     * The other participant's username in a DIRECT chat; null for a group and until the
     * conversation loads.
     *
     * A username rather than a display name or an id, because `user/{username}` and the
     * contract's `getUserByUsername` are both keyed that way. Null is what makes the header
     * inert: a group header has no single person behind it, and this screen would otherwise have
     * to guess.
     */
    peerUsername: String? = null,
    /**
     * SDS §4.7 / §11.5: the green dot on the header avatar.
     *
     * Separate from [subtitle] rather than derived from it, because the two answer different
     * questions: the subtitle is a SENTENCE ("online", "last seen yesterday at 21:14") that has to
     * be localizable, and this is a boolean the dot switches on. Parsing the word "online" back
     * out of a translated string to decide whether to draw a dot is exactly the coupling that
     * breaks the moment the app ships in Russian.
     */
    isOnline: Boolean = false,
    /**
     * The photo on the header avatar: the group's own for a group, the other participant's for a
     * direct chat. Null falls back to the initials, which is also what an unreachable URL does.
     */
    avatarUrl: String? = null,
    peerHasBlackBadge: Boolean = false,
    /** Opens a public profile by username. No-op by default, so previews and tests need none. */
    onOpenProfile: (String) -> Unit = {},
    /**
     * Display names of everybody else currently typing, already expired by the view model.
     *
     * Empty leaves [subtitle] alone; anything else TEMPORARILY REPLACES it in the header. See
     * [typingLabel] for why the header is the only place this appears.
     */
    typingNames: List<String> = emptyList(),
    /**
     * Raised as the draft changes, so the view model can publish `typing`. It is given the whole
     * draft rather than a boolean because "stopped typing" is "the field is empty", and only the
     * composer knows that.
     */
    onDraftChanged: (String) -> Unit = {},
    /**
     * Picks and sends an image. NULL means this build cannot pick images -- no chooser is wired on
     * this platform -- and the button is then not drawn at all, rather than drawn and inert.
     */
    onAttachImage: (() -> Unit)? = null,
    /** An image is uploading. Disables the attach button so a second pick cannot race the first. */
    attachmentInFlight: Boolean = false,
    voiceComposer: VoiceComposerState = VoiceComposerState(),
    voicePlayback: VoicePlaybackState = VoicePlaybackState(),
    onVoiceStart: (() -> Unit)? = null,
    onVoiceRelease: () -> Unit = {},
    onVoiceLock: () -> Unit = {},
    onVoiceCancel: () -> Unit = {},
    onVoicePauseResume: () -> Unit = {},
    onVoiceSend: () -> Unit = {},
    onVoicePlaybackToggle: (Message) -> Unit = {},
    onVoicePlaybackSeek: (Message, Long) -> Unit = { _, _ -> },
    onVoicePlaybackSpeed: (Message) -> Unit = {},
    /**
     * The conversation's pinned messages, newest pin first, capped at five by the contract.
     *
     * Empty draws no banner at all, which is why this needs no "loaded" guard of its own: an empty
     * pin list and an unread one look identical, and neither asserts anything.
     */
    pinnedMessages: List<Message> = emptyList(),
    /**
     * SDS §12.5 / SPS §10.13's `Pin`. Null hides the message menu entirely rather than offering an
     * action that cannot run -- the same contract every other nullable handler on this screen has.
     */
    onSetPinned: ((MessageId, Boolean) -> Unit)? = null,
    composerContext: ComposerContext = ComposerContext.None,
    onReply: ((Message?) -> Unit)? = null,
    onEdit: ((Message?) -> Unit)? = null,
    onSaveEdit: ((String) -> Unit)? = null,
    /** The outcome of the last pin -- the five-per-conversation limit, or a failure. */
    pinNotice: UiText? = null,
    onDismissPinNotice: (() -> Unit)? = null,
    /**
     * SDS §12.5's `Report`, raised from the long-press menu.
     *
     * Null when reporting is not wired on this build, and the entry is then not drawn at all rather
     * than drawn and inert -- the rule every nullable handler on this screen follows, and the one
     * that matters most on a safety control: a Report that silently does nothing leaves the user
     * believing they have been heard.
     *
     * The screen builds the whole [ReportRequest] because it is the only thing here that knows both
     * the message and who sent it; `ui/moderation` owns everything after that.
     */
    onReport: ((ReportRequest) -> Unit)? = null,
    /**
     * SPS §19.5 / STA §4.8: "Failed messages should show a retry action." Given the message's
     * `client_id`, which is the identity the outbox row is keyed by -- an unsent message has no
     * server id to name it with, which is precisely why it is unsent.
     */
    onRetryMessage: ((String) -> Unit)? = null,
    /** Abandons an unsent message. Local only; nothing on the server knows about it. */
    onDiscardMessage: ((String) -> Unit)? = null,
    /** SDS §12.5's Delete. The boolean is the contract's `scope`: true is `everyone`. */
    onDeleteMessage: ((MessageId, Boolean) -> Unit)? = null,
    onReact: ((MessageId, String) -> Unit)? = null,
    onOpenPicso: ((String) -> Unit)? = null,
    /** Available destinations for the in-app forwarding picker. */
    forwardTargets: List<Chat> = emptyList(),
    /** Forwards the source ids to one destination, preserving their original media server-side. */
    onForwardMessages: ((List<MessageId>, ChatId) -> Unit)? = null,
    /**
     * Why the last send or retry failed, in a sentence. Sits above the timeline as its own banner:
     * a failed send is not a failed conversation, so it must not replace [error] and a later
     * successful refresh must not silently erase it.
     */
    sendNotice: UiText? = null,
    onDismissSendNotice: (() -> Unit)? = null,
    /**
     * Ask the server again. TWO CONTROLS, one handler: SDS §19.4's pull-to-refresh on the empty
     * states, and the header's Refresh action -- which is the only one a POPULATED conversation
     * has, and the only one a screen reader or a switch can reach. Null draws neither.
     */
    onRefresh: (() -> Unit)? = null,
    refreshing: Boolean = false,
    /**
     * Asks for one page of older history. Raised as the reader approaches the top of what is
     * loaded; the view model decides whether that costs a request or merely a larger cache window.
     */
    onLoadOlder: (() -> Unit)? = null,
    /**
     * False until the first read of this conversation has settled.
     *
     * Guards the empty state, and nothing else: an empty timeline means "no messages" only once
     * somebody has actually looked. See `ChatViewModel.loadedOnce`. Defaulted true so previews and
     * tests, which hand this screen a finished list, are unaffected.
     */
    loadedOnce: Boolean = true,
    zone: TimeZone = TimeZone.currentSystemDefault(),
    squadStreak: SquadStreakDomain? = null,
    nudgeInProgress: Boolean = false,
    startStreakInProgress: Boolean = false,
    onStartSquadStreak: () -> Unit = {},
    onNudgeSquadStreak: () -> Unit = {},
) {
    val replyingTo = (composerContext as? ComposerContext.Reply)?.message
    val editingMessage = (composerContext as? ComposerContext.Edit)?.message
    val items = remember(messagesNewestFirst, zone) { buildTimeline(messagesNewestFirst, zone) }
    val listState = rememberLazyListState()
    val reducedMotion = reduceMotion()
    val clipboard = LocalClipboardManager.current
    val now = remember { Clock.System.now() }
    var actionsFor by remember { mutableStateOf<Message?>(null) }
    var reactionsFor by remember { mutableStateOf<ReactionPickerTarget?>(null) }
    var timelineBounds by remember { mutableStateOf<IntRect?>(null) }
    var mediaAnchor by remember { mutableStateOf<IntRect?>(null) }
    var mediaFor by remember { mutableStateOf<Message?>(null) }
    val reactionClearance = reactionPickerHeight() + Space.one
    val reactionClearancePx = with(LocalDensity.current) { reactionClearance.roundToPx() }
    var selectedIds by remember { mutableStateOf<Set<String>>(emptySet()) }
    var forwardingMessages by remember { mutableStateOf<List<Message>>(emptyList()) }
    var confirmingSelectionDelete by remember { mutableStateOf(false) }
    var showPinnedList by remember { mutableStateOf(false) }
    val pinnedIds = remember(pinnedMessages) { pinnedMessages.map { it.id }.toSet() }
    val selectedMessages = remember(messagesNewestFirst, selectedIds) {
        messagesNewestFirst.filter { it.id.value in selectedIds }
    }
    val selectionMode = selectedIds.isNotEmpty()
    val reactionMessage = reactionsFor?.let { target ->
        messagesNewestFirst.firstOrNull { it.id == target.messageId }
    }

    LaunchedEffect(listState.isScrollInProgress, selectionMode) {
        if (listState.isScrollInProgress || selectionMode) reactionsFor = null
    }
    LaunchedEffect(reactionsFor?.messageId, canShowReactionPicker(reactionMessage), onReact != null) {
        if (!canShowReactionPicker(reactionMessage) || onReact == null) reactionsFor = null
    }

    LaunchedEffect(messagesNewestFirst) {
        val visibleIds = messagesNewestFirst.mapTo(mutableSetOf()) { it.id.value }
        selectedIds = selectedIds.intersect(visibleIds)
    }

    // The identity of the row at the BOTTOM of the conversation -- index 0, because the list is
    // reversed. Everything about following the timeline keys off this changing.
    val newestKey = items.firstOrNull()?.rowKey()
    val newestIsMine =
        (items.firstOrNull() as? TimelineItem.MessageRow)?.message?.sender?.id == me
    // False until the first non-empty timeline has been placed, so the initial paint jumps to the
    // bottom instantly instead of animating there from wherever an empty list starts.
    var painted by remember { mutableStateOf(false) }

    /*
     * Follow the conversation.
     *
     * Without this the screen is broken in the way every hand-built chat list is broken: the rows
     * carry a STABLE key (which they must, or prepending history recycles rows under the reader's
     * finger), so when a new message arrives at index 0 the list keeps its anchor on the key that
     * used to be first and quietly pushes the new bubble off the bottom edge, behind the composer.
     * Sending a message and receiving one both land there.
     *
     * Following is conditional, because always scrolling is its own defect: someone reading back
     * through history must not be yanked to the bottom because a message arrived. Two cases follow:
     * a message the user just SENT (they are the reason it exists, so they get taken to it wherever
     * they were), and a list that is already parked at the bottom. `firstVisibleItemIndex` is
     * checked against a small slop rather than 0 because by the time this runs the prepend has
     * already shifted the old anchor down by one row -- two, when a day separator came with it.
     */
    LaunchedEffect(newestKey) {
        reactionsFor = null
        if (newestKey == null) return@LaunchedEffect
        if (!painted) {
            painted = true
            listState.scrollToItem(0)
            return@LaunchedEffect
        }
        if (newestIsMine || listState.firstVisibleItemIndex <= FOLLOW_SLOP_ROWS) {
            if (reducedMotion || listState.firstVisibleItemIndex > MAX_ANIMATED_FOLLOW_ROWS) {
                listState.scrollToItem(0)
            } else {
                listState.animateScrollToItem(0)
            }
        }
    }

    /*
     * Reach the top of what is loaded, ask for more.
     *
     * The list is REVERSED, so "older" is the END of it -- the last visible index, not the first.
     * `derivedStateOf` is what keeps this off the recomposition path: reading `layoutInfo`
     * directly in composition would recompose this whole screen on every scrolled pixel.
     *
     * A THRESHOLD RATHER THAN THE LAST ROW, so the page is already in flight by the time the
     * reader gets there and history appears without a visible stall. `onLoadOlder` is re-entrant
     * -- the view model refuses a second call while one is running -- so a burst of triggers
     * during a fast fling costs nothing.
     */
    // Keyed on `items`, not bare `remember`: the list is rebuilt on every timeline emission, and
    // a derived state that captured the FIRST one would go on answering a question about a
    // conversation that has since changed -- true forever after the first short page, or never
    // true again after it grew.
    val wantsOlder by remember(items, listState) {
        derivedStateOf {
            val lastVisible = listState.layoutInfo.visibleItemsInfo.lastOrNull()?.index ?: 0
            items.isNotEmpty() && lastVisible >= items.lastIndex - LOAD_OLDER_SLOP_ROWS
        }
    }
    LaunchedEffect(wantsOlder, items.size) {
        if (wantsOlder) onLoadOlder?.invoke()
    }

    // Whether the long-press menu can offer anything at all. Widened past `onSetPinned` and
    // `onReport`: a build with only the retry and delete handlers wired would otherwise draw a
    // bubble with no gesture on it, and a FAILED message would be back to having no way out.
    val hasMessageMenu = onSetPinned != null || onReport != null ||
        onRetryMessage != null || onDeleteMessage != null || onDiscardMessage != null ||
        onReply != null || onEdit != null

    val someoneIsTyping = typingNames.isNotEmpty()

    Column(
        modifier
            .fillMaxSize()
            // THE CANVAS, edge to edge, header included. `background.deep` -- #000000 in the dark
            // theme -- which SDS §4.3 reserves for "deepest background only". The user asked for the
            // mockup over the SDS; the override is recorded in DECISIONS.md §25 and in `ChatColors`.
            //
            // "EDGE TO EDGE" TAKES TWO FILES, and this is only one of them. The app frame in
            // `ui/Navigation.kt` paints the whole window and insets every screen below the status
            // bar, so the strip behind the status bar is the frame's colour rather than this one.
            // The frame follows the destination for exactly this reason -- see `frameBackground`
            // there. The bottom edge is handled here: the composer's Surface wraps its own
            // `navigationBarsPadding`, so the canvas runs under the gesture bar.
            .background(SwetgramThemeTokens.chat.canvas),
    ) {
        if (selectionMode) {
            MessageSelectionHeader(
                count = selectedMessages.size,
                canCopy = selectedMessages.any { !it.text.isNullOrBlank() },
                canForward = onForwardMessages != null && selectedMessages.all {
                    it.isAcknowledged() && !it.isDeleted && it.isForwardable()
                },
                canDelete = onDeleteMessage != null || onDiscardMessage != null,
                onClose = { selectedIds = emptySet() },
                onCopy = {
                    selectedMessages.mapNotNull { it.text?.takeIf(String::isNotBlank) }
                        .takeIf(List<String>::isNotEmpty)
                        ?.joinToString("\n")
                        ?.let { clipboard.setText(AnnotatedString(it)) }
                },
                onForward = { forwardingMessages = selectedMessages.sortedBy { it.sentAt } },
                onDelete = { confirmingSelectionDelete = true },
            )
        } else {
            ChatHeader(
                title = title,
                subtitle = chatHeaderSubtitle(typingNames, subtitle),
                isOnline = isOnline,
                avatarUrl = avatarUrl,
                hasBlackBadge = peerHasBlackBadge,
                onBack = onBack,
                peerUsername = peerUsername,
                onOpenProfile = onOpenProfile,
                announceSubtitle = someoneIsTyping,
                onRefresh = onRefresh,
                refreshing = refreshing,
            )
        }

        if (squadStreak != null || peerUsername != null) {
            SquadStreakBanner(
                streak = squadStreak,
                myUserId = me.value,
                peerName = peerUsername,
                nudgeInProgress = nudgeInProgress,
                startInProgress = startStreakInProgress,
                onStartStreak = onStartSquadStreak,
                onNudge = onNudgeSquadStreak,
            )
        }

        /*
         * Above the timeline, never instead of it: a failed refresh must not look like the
         * conversation was lost. The SENTENCE is the view model's, and it is not the same sentence
         * over an empty screen as it is over a cached one -- see `ChatViewModel.chatBannerMessage`.
         *
         * AND IT CAN BE PUT AWAY. It was the only banner on this screen without a dismiss, so a
         * user looking at a perfectly good cached conversation had no way to stop looking at a red
         * bar about it. The dismissal is SCREEN-LOCAL rather than a handler on the view model,
         * because the fact being dismissed is "I have read this", not "the refresh no longer
         * failed": the view model's state is still true and its Retry still works.
         *
         * It re-arms itself when a refresh SETTLES. Without that, dismissing and then pressing
         * Refresh would swallow an identical second failure -- the user asked, it failed again, and
         * the screen would have said nothing.
         */
        //
        // THE DISMISSAL IS KEYED ON THE RENDERED SENTENCE, not on the `UiText` that chose it, and
        // that is `rememberSaveable`'s constraint rather than a preference: a saved value has to
        // survive process death, and `UiText` holds a `StringResource` which has no saver. The
        // resolved String is what the bundle can carry, and it compares exactly as the old code did.
        var dismissedError by rememberSaveable { mutableStateOf<String?>(null) }
        LaunchedEffect(refreshing) { if (!refreshing) dismissedError = null }
        val errorText = error?.resolve()
        val visibleError = errorText?.takeIf { it != dismissedError }
        if (visibleError != null) {
            SwetErrorBanner(
                message = visibleError,
                onRetry = onRetry,
                onDismiss = { dismissedError = visibleError },
            )
        }
        // A refused pin is reported apart from the conversation's own state, so hitting the
        // five-message limit does not make the timeline look broken. Dismissible because nothing
        // else will clear it -- a later refresh has no opinion about a pin that never happened.
        if (pinNotice != null) {
            SwetErrorBanner(message = pinNotice.resolve(), onDismiss = onDismissPinNotice)
        }
        // A send that failed is reported apart from both of those. SDS §25.1: an error state has
        // to explain what happened, and a red glyph the size of a tick explains nothing.
        // Dismissible because nothing else clears it -- a later refresh has no opinion about a
        // message that never went.
        if (sendNotice != null) {
            SwetErrorBanner(message = sendNotice.resolve(), onDismiss = onDismissSendNotice)
        }

        // SDS §12.5 and SPS §10.13 give `Pin` an action but say nothing about where a pinned
        // message is then SHOWN -- see [PinnedBanner] for the whole of that decision.
        if (pinnedMessages.isNotEmpty()) {
            PinnedBanner(
                pinned = pinnedMessages,
                me = me,
                onClick = { showPinnedList = true },
            )
        }

        /*
         * PULL-TO-REFRESH, AND WHY IT IS ONLY ON THE EMPTY STATES.
         *
         * The conversation is the one surface in this app with no manual recovery: its only other
         * source of updates is the socket, whose `runLoop` swallows failures and backs off to a
         * 30-second cap, so with a dead socket the screen renders exactly as it does when healthy
         * and simply never receives another message. Every other list -- the chat list, Discover,
         * Groups, a post thread, the moderation queue -- answers that with `SwetPullToRefresh`,
         * and the obvious fix was to give this one the same wrapper.
         *
         * IT DOES NOT TRANSFER, and the reason is one line above: `reverseLayout = true`. This is
         * the only reversed list in the app. `PullToRefreshBox` fires on a DOWNWARD drag the child
         * did not consume, and in a reversed list a downward drag scrolls INTO HISTORY -- so the
         * unconsumed edge is the top of the OLDEST loaded message, not the newest. Wrapping the
         * timeline would put "reload the newest page" on the one gesture that already means "load
         * older", firing at the far end of history where nobody looking for fresh messages will
         * ever be, and pre-empting `onLoadOlder` when they get there.
         *
         * So the gesture is applied where there IS no reversed list to fight: a conversation that
         * is empty or has not loaded, which is the case a pull most plainly means something in.
         *
         * THE GAP THIS LEFT IS NOW CLOSED, and not by moving the gesture. A populated conversation
         * used to have no recovery at all short of the error banner's Retry, which only exists once
         * something has already failed -- so a conversation that was merely stale had nothing. The
         * answer is the Refresh action in the header above, which is also the accessible one (SDS
         * §22.4: a pull is a gesture with no equivalent to focus or activate). Recorded in
         * DECISIONS §22.
         */
        val timelineModifier = Modifier
            .weight(1f)
            .fillMaxWidth()
            // THE HORIZONTAL INSETS, which nothing on this screen applied.
            //
            // The activity runs edge to edge and `ui/Navigation.kt` insets the STATUS bar for
            // every screen; the composer below insets the navigation bar. Nothing insets the
            // sides -- so in landscape, where the gesture pill or the three-button bar sits on
            // one edge and a notch on the other, a bubble is drawn underneath both. The timeline
            // is the only part of this screen that reaches the edge, because every bubble is
            // right- or left-aligned against it.
            //
            // `safeDrawing` rather than `systemBars`, so a display cutout counts too, and
            // `only(Horizontal)` so the vertical insets stay where they are already handled.
            // REPORTED FROM A LANDSCAPE SCREENSHOT AND FIXED FROM THE CODE: this pass had no
            // device, so what is verified is that no horizontal inset was applied anywhere on the
            // message list, not that the result looks right.
            .windowInsetsPadding(WindowInsets.safeDrawing.only(WindowInsetsSides.Horizontal))
            .onGloballyPositioned { timelineBounds = it.boundsInWindow().reactionBounds() }

        if (items.isEmpty()) {
            SwetPullToRefresh(
                refreshing = refreshing,
                onRefresh = onRefresh,
                modifier = timelineModifier,
            ) {
                if (!loadedOnce) {
                    // Nothing to show and nobody has looked yet, so this says NOTHING rather than
                    // guessing. The timeline arrives from the cache in a frame or two and fills it
                    // in.
                    //
                    // Blank rather than skeleton bubbles, which is the one place this screen
                    // departs from the chat list's placeholder rows: a row has a fixed 72dp shape
                    // to stand in for, and a conversation does not -- bubbles vary in width,
                    // height and side, so a skeleton would have to invent a conversation and would
                    // land nowhere near the real one. The header and the composer are already
                    // drawn, so the screen reads as itself while it waits.
                    Box(Modifier.fillMaxSize())
                } else {
                    // SDS §17.2. A conversation with no messages is a normal state -- a chat
                    // opened from a profile or the New Chat flow starts here -- and an empty grey
                    // rectangle above a composer reads as a screen that failed to load.
                    //
                    // Reached only once [loadedOnce] is true, so "No messages yet." is now
                    // something the screen KNOWS rather than its opening assumption about every
                    // conversation.
                    SwetEmptyState(
                        title = stringResource(Res.string.chat_empty_title),
                        body = stringResource(Res.string.chat_empty_body),
                        modifier = Modifier.fillMaxSize(),
                    )
                }
            }
        } else {
            LazyColumn(
                modifier = timelineModifier,
                state = listState,
                // The list is built newest-first and drawn bottom-up, which is what every
                // messenger does: new messages appear at the bottom and the view stays
                // anchored there.
                reverseLayout = true,
                contentPadding = PaddingValues(vertical = Space.one),
            ) {
                items(
                    count = items.size,
                    // A STABLE key per row. Without it, prepending a page of history recycles
                    // rows and the list visibly jumps under the reader's finger -- the single
                    // most common defect in hand-built chat screens.
                    key = { index -> items[index].rowKey() },
                ) { index ->
                    when (val item = items[index]) {
                        is TimelineItem.MessageRow -> MessageRowWithActions(
                            modifier = swetAnimateMessageItem(),
                            message = item.message,
                            me = me,
                            members = members,
                            // `item.isRunStart` / `item.isRunEnd` are deliberately NOT passed. The
                            // mockup draws the sender's avatar on every incoming row and gives every
                            // bubble the same four corners, so there is no run for them to describe.
                            // They stay on `TimelineItem` because the domain computes and tests them.
                            // The same zone the separators and the grouping use, so a bubble
                            // cannot print a time from a different day than the header above.
                            zone = zone,
                            // A GROUP NAMES ITS SENDERS OUT LOUD, a 1:1 does not. `peerUsername`
                            // is the signal already on this screen -- it is what decides whether
                            // the header draws the ⓘ -- and it is null for a group because a
                            // group has no single person behind it. Visual output is identical
                            // either way; only the avatar's semantics change.
                            announceSender = peerUsername == null,
                            // SDS §25.1: an error state has to explain what happened. Drawn
                            // outside the bubble rather than inside it, because it is a sentence
                            // ABOUT the message rather than part of it -- a wrapped sentence in
                            // the bubble would read as something the sender wrote, which is the
                            // one thing a failed send must not look like.
                            failureNote = failedSendNote(
                                message = item.message,
                                me = me,
                                hasActions = hasMessageMenu,
                            ).resolveOrNull(),
                            voicePlayback = voicePlayback,
                            onVoicePlaybackToggle = onVoicePlaybackToggle,
                            onVoicePlaybackSeek = onVoicePlaybackSeek,
                            onVoicePlaybackSpeed = onVoicePlaybackSpeed,
                            selectionMode = selectionMode,
                            selected = item.message.id.value in selectedIds || actionsFor?.id == item.message.id,
                            reactionTarget = reactionsFor?.takeIf { it.messageId == item.message.id },
                            reactionClearance = reactionClearance,
                            // Null when the menu would be EMPTY: the bubble then carries no
                            // gesture at all rather than one that opens nothing. The double
                            // brace is the usual Kotlin dance: `else { ... }` is a BLOCK, so
                            // the lambda needs its own pair.
                            onLongPress = if (selectionMode) {
                                {
                                    selectedIds = if (item.message.id.value in selectedIds) {
                                        selectedIds - item.message.id.value
                                    } else {
                                        selectedIds + item.message.id.value
                                    }
                                }
                            } else if (!hasMessageMenu) {
                                null
                            } else {
                                {
                                    reactionsFor = null
                                    actionsFor = item.message
                                }
                            },
                            onTap = if (selectionMode) {
                                {
                                    selectedIds = if (item.message.id.value in selectedIds) {
                                        selectedIds - item.message.id.value
                                    } else {
                                        selectedIds + item.message.id.value
                                    }
                                }
                            } else if (item.message.picso != null && !item.message.isDeleted && onOpenPicso != null) {
                                { onOpenPicso(item.message.picso.id) }
                            } else when (messageTapAction(item.message, onReact != null)) {
                                MessageTapAction.Media -> {
                                    { bounds ->
                                        reactionsFor = null
                                        mediaAnchor = bounds
                                        mediaFor = item.message
                                    }
                                }
                                MessageTapAction.Reactions -> {
                                    { bounds ->
                                        reactionsFor = if (reactionsFor?.messageId == item.message.id) null
                                        else reactionPickerTarget(
                                            item.message.id, bounds, timelineBounds, reactionClearancePx,
                                        )
                                    }
                                }
                                MessageTapAction.None -> null
                            },
                            onBubbleBoundsChanged = if (
                                reactionsFor?.messageId == item.message.id || mediaFor?.id == item.message.id
                            ) {
                                { bounds ->
                                    reactionsFor?.takeIf { it.messageId == item.message.id && it.bounds != bounds }
                                        ?.let { reactionsFor = it.copy(bounds = bounds) }
                                    if (mediaFor?.id == item.message.id && mediaAnchor != bounds) mediaAnchor = bounds
                                }
                            } else null,
                            onSwipeReply = if (
                                !selectionMode &&
                                onReply != null &&
                                item.message.isAcknowledged() &&
                                !item.message.isDeleted
                            ) {
                                { onReply(item.message) }
                            } else {
                                null
                            },
                            onReactionClick = { emoji ->
                                item.message.id.takeIf { it.value != item.message.clientId }?.let { id ->
                                    onReact?.invoke(id, emoji)
                                }
                            },
                        )
                        is TimelineItem.DaySeparator -> DaySeparatorRow(
                            label = dayLabel(item.day, now, zone),
                        )
                    }
                }
            }
        }

        if (selectionMode) {
            MessageSelectionBottomBar(
                canReply = selectedMessages.size == 1 && onReply != null &&
                    selectedMessages.single().isAcknowledged() && !selectedMessages.single().isDeleted,
                canForward = onForwardMessages != null && selectedMessages.all {
                    it.isAcknowledged() && !it.isDeleted && it.isForwardable()
                },
                onReply = {
                    selectedMessages.singleOrNull()?.let { onReply?.invoke(it) }
                    selectedIds = emptySet()
                },
                onForward = { forwardingMessages = selectedMessages.sortedBy { it.sentAt } },
            )
        } else Composer(
            // SPS §10.10 / SDS §12.3: `Message @alex...` in a direct chat, the group's name in a
            // group. The username is passed rather than dropped, which is what made every direct
            // chat read `Message Alex Kim...` instead of the handle the spec writes.
            placeholder = composerPlaceholder(title, peerUsername).resolve(),
            replyingTo = replyingTo,
            onCancelReply = { onReply?.invoke(null) },
            editingMessage = editingMessage,
            onCancelEdit = { onEdit?.invoke(null) },
            onSaveEdit = { text -> onSaveEdit?.invoke(text) },
            onSend = onSend,
            onDraftChanged = onDraftChanged,
            onAttachImage = onAttachImage.takeIf { editingMessage == null },
            attachmentInFlight = attachmentInFlight,
            voice = voiceComposer,
            onVoiceStart = onVoiceStart.takeIf { editingMessage == null },
            onVoiceRelease = onVoiceRelease,
            onVoiceLock = onVoiceLock,
            onVoiceCancel = onVoiceCancel,
            onVoicePauseResume = onVoicePauseResume,
            onVoiceSend = onVoiceSend,
            me = me,
        )
    }

    // SDS §12.5's long-press menu, with the actions of it this build can perform.
    actionsFor?.let { message ->
        MessageActionsDialog(
            message = message,
            me = me,
            isPinned = message.id in pinnedIds,
            canPin = onSetPinned != null,
            canReply = onReply != null,
            canEdit = onEdit != null,
            canForward = onForwardMessages != null,
            // §12.5's own rule: "Report should be available for messages not sent by the current
            // user." The server would accept a report against your own message -- `createReport`
            // puts no ownership condition on a `message` target -- so this is the folder's decision
            // rather than the contract's, and it is right: reporting yourself is not a thing anybody
            // means to do, and the row would only ever be a mis-tap.
            canReport = onReport != null && !message.isMine(me),
            // Deleting an UNSENT message needs no server call at all, so the entry is offered
            // whenever either half is wired -- a build with the discard handler and not the
            // delete one can still let the user clear a message that never went.
            canDelete = onDeleteMessage != null || onDiscardMessage != null,
            onDismiss = { actionsFor = null },
            onSetPinned = { pinned ->
                actionsFor = null
                onSetPinned?.invoke(message.id, pinned)
            },
            onReply = {
                actionsFor = null
                onReply?.invoke(message)
            },
            onEdit = {
                actionsFor = null
                onEdit?.invoke(message)
            },
            onCopy = {
                actionsFor = null
                // The most-used entry in any messenger's message menu, and there was no way to
                // copy message text at all. `LocalClipboardManager` is what `GroupInviteScreen`
                // and `ProfileScreen` already use for the same job.
                message.text?.takeIf { it.isNotBlank() }?.let { clipboard.setText(AnnotatedString(it)) }
            },
            onForward = {
                actionsFor = null
                forwardingMessages = listOf(message)
            },
            onSelect = {
                actionsFor = null
                selectedIds = setOf(message.id.value)
            },
            onReact = { emoji -> onReact?.invoke(message.id, emoji) },
            onRetry = {
                actionsFor = null
                onRetryMessage?.invoke(message.clientId)
            },
            onDelete = { forEveryone ->
                actionsFor = null
                // A message the server never accepted is discarded locally: calling
                // `deleteMessage` for it would name an id the server has never seen and answer
                // 404, leaving the row exactly where it was.
                if (message.isMine(me) && message.state == MessageState.FAILED) {
                    onDiscardMessage?.invoke(message.clientId)
                } else {
                    onDeleteMessage?.invoke(message.id, forEveryone)
                }
            },
            onReport = {
                actionsFor = null
                onReport?.invoke(
                    ReportRequest(
                        target = ReportTarget.Message(message.id),
                        // The SENDER, not the reader. It is what makes SPS §16.2's block offer
                        // possible on the receipt -- reporting a message and blocking the person who
                        // sent it are the two things somebody wants at that moment.
                        //
                        // NULL FOR A DELETED ACCOUNT. `Mappers.kt` gives a deleted sender an empty
                        // username and possibly an empty id, so a block offer built from one would
                        // read "Block @" and would POST to `users//block`. There is nobody left to
                        // block; the report still files, because the message is still on screen.
                        account = message.sender
                            .takeIf { !it.isDeleted && it.username.isNotBlank() }
                            ?.let {
                                ReportedAccount(
                                    userId = it.id,
                                    username = it.username,
                                    displayName = it.displayName,
                                )
                            },
                    ),
                )
            },
        )
    }

    if (forwardingMessages.isNotEmpty()) {
        ForwardMessagesDialog(
            chats = forwardTargets,
            me = me,
            onDismiss = { forwardingMessages = emptyList() },
            onTarget = { target ->
                val sourceIds = forwardingMessages.map { it.id }
                forwardingMessages = emptyList()
                selectedIds = emptySet()
                onForwardMessages?.invoke(sourceIds, target.id)
            },
        )
    }

    if (confirmingSelectionDelete && selectedMessages.isNotEmpty()) {
        DeleteSelectedMessagesDialog(
            canDeleteForEveryone = selectedMessages.all {
                it.isAcknowledged() && it.canDeleteForEveryone
            },
            onDismiss = { confirmingSelectionDelete = false },
            onDelete = { forEveryone ->
                selectedMessages.forEach { message ->
                    if (message.isMine(me) && message.state == MessageState.FAILED) {
                        onDiscardMessage?.invoke(message.clientId)
                    } else {
                        onDeleteMessage?.invoke(message.id, forEveryone)
                    }
                }
                confirmingSelectionDelete = false
                selectedIds = emptySet()
            },
        )
    }

    val reactionTarget = reactionsFor
    val reactionViewport = timelineBounds
    if (
        reactionTarget != null && reactionMessage != null && canShowReactionPicker(reactionMessage) &&
        reactionViewport != null && reactionViewport.width > 0 && reactionViewport.height > 0 &&
        !listState.isScrollInProgress && !selectionMode && onReact != null
    ) {
        FloatingReactionPicker(
            target = reactionTarget,
            message = reactionMessage,
            viewport = reactionViewport,
            mine = reactionMessage.isMine(me),
            onDismiss = { reactionsFor = null },
            onReact = { emoji ->
                // Removing the target before sending also ignores duplicate clicks on the closing popup.
                if (reactionsFor?.messageId == reactionTarget.messageId) {
                    reactionsFor = null
                    onReact(reactionTarget.messageId, emoji)
                }
            },
        )
    }

    mediaFor?.let { message ->
        ChatMediaViewer(
            message = message,
            zone = zone,
            onDismiss = { mediaFor = null },
            onReact = if (
                onReact != null && message.isAcknowledged() && !message.isDeleted
            ) {
                {
                    mediaFor = null
                    (mediaAnchor ?: timelineBounds)?.let {
                        reactionsFor = reactionPickerTarget(
                            message.id, it, timelineBounds, reactionClearancePx,
                        )
                    }
                }
            } else {
                null
            },
        )
    }

    // The list is refreshed from the server after each unpin, so unpinning the last one leaves
    // this dialog with nothing to show. An effect rather than a check inside the `if`: writing
    // state during composition is what makes a recomposition loop.
    LaunchedEffect(pinnedMessages.isEmpty()) {
        if (pinnedMessages.isEmpty()) showPinnedList = false
    }

    if (showPinnedList && pinnedMessages.isNotEmpty()) {
        PinnedMessagesDialog(
            pinned = pinnedMessages,
            me = me,
            onDismiss = { showPinnedList = false },
            onUnpin = { id ->
                // The sheet stays open: unpinning three of five is one gesture per message, and
                // closing after each would make the user reopen it to reach the next one.
                onSetPinned?.invoke(id, false)
            },
        )
    }
}

// ---------------------------------------------------------------------------------------------
// Pinned messages -- SDS §12.5 / SPS §10.13
// ---------------------------------------------------------------------------------------------

/**
 * The pinned-message strip under the header.
 *
 * WHAT THE SPECS ACTUALLY SAY, because it is less than the feature needs. SPS §10.13 and SDS §12.5
 * both list `Pin` in the message long-press menu and neither says another word about it: there is
 * no banner, no pinned-messages screen and no placement rule anywhere in either document. The
 * contract is what makes the shape necessary -- `listPinnedMessages` is a separate endpoint capped
 * at five per conversation -- so a pin has to be visible somewhere or the action writes to a list
 * with no reader.
 *
 * So this is BOTH of the two shapes, and the choice is recorded here rather than presented as
 * spec: a strip showing the newest pin, which is the whole answer when there is one, and a tap
 * into the full list when there is more than one. SDS §12.4 asks for "Telegram-like familiar"
 * conversation chrome and this is the familiar form of it.
 *
 * Everything visual is a token. The accent rule on the left is the only ornament, and it is the
 * same accent the composer's send button and the typing line use for "live, not content".
 */
@Composable
private fun PinnedBanner(
    pinned: List<Message>,
    me: UserId,
    onClick: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    val newest = pinned.first()

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(colors.surface)
            .swetPressable(
                // A PLURAL, not `if (size == 1)`. English has two forms and Russian has three, and
                // the form for 2 is not the form for 5: `закреплённые сообщения` against
                // `закреплённых сообщений`. The count picks the form; the file supplies it.
                onClickLabel = pluralStringResource(Res.plurals.chat_pinned_open, pinned.size),
                onClick = onClick,
            )
            .padding(horizontal = Space.two, vertical = Space.one),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        // The rule that makes a quotation read as a quotation. Two hairlines wide, so it holds up
        // next to the 1dp borders the rest of the app draws.
        Box(
            Modifier
                .width(Sizes.borderHairline * 2)
                .height(Sizes.iconLarge)
                .background(colors.accent),
        )
        Spacer(Modifier.width(Space.one + Space.half))

        Column(Modifier.weight(1f)) {
            Text(
                text = pluralStringResource(Res.plurals.chat_pinned_heading, pinned.size),
                style = MaterialTheme.typography.labelMedium,
                // WHITE, NOT THE ACCENT, and the rule beside it is why the heading can afford to be.
                // `accent` is dark enough to carry a white label on top of it, which is exactly what
                // makes it illegible AS a label: at `labelMedium` on this `surface` it does not
                // reach AA, and no single red does both jobs. The accent stays where it is a FILL
                // -- the 3dp rule above -- and the words it was marking take `text.primary`.
                color = colors.textPrimary,
            )
            Text(
                text = pinnedPreviewLine(newest, me),
                style = MaterialTheme.typography.bodySmall,
                color = colors.textSecondary,
            )
        }

        if (pinned.size > 1) {
            Spacer(Modifier.width(Space.one))
            // Announced with its meaning rather than as a bare number, which on its own reads as
            // part of the message above it. Resolved BEFORE the semantics lambda, which is not
            // composable and cannot reach a resource from inside itself.
            val badgeDescription = pluralStringResource(Res.plurals.chat_pinned_count, pinned.size, pinned.size)
            Text(
                text = "${pinned.size}",
                style = MaterialTheme.typography.labelMedium,
                color = colors.textSecondary,
                modifier = Modifier.semantics { contentDescription = badgeDescription },
            )
        }
    }
}

/**
 * All the pinned messages, each with the way back out.
 *
 * The unpin is the "clear way back" a reversible action owes the user, and it is deliberately here
 * rather than only in the long-press menu: a message pinned last week is far up the timeline, and
 * requiring the user to find it before they can unpin it makes the cap unmanageable.
 *
 * No confirmation. SDS §11.1 asks for one before a DESTRUCTIVE action, and unpinning destroys
 * nothing -- the message stays exactly where it was in the conversation. (This comment used to
 * cite §12.2, which is the chat list's swipe actions; the conclusion is unchanged.)
 */
@Composable
private fun PinnedMessagesDialog(
    pinned: List<Message>,
    me: UserId,
    onDismiss: () -> Unit,
    onUnpin: (MessageId) -> Unit,
) {
    val colors = SwetgramThemeTokens.colors

    ChatDialog(onDismiss = onDismiss) {
        Text(
            text = pluralStringResource(Res.plurals.chat_pinned_heading, pinned.size),
            style = MaterialTheme.typography.titleLarge,
            color = colors.textPrimary,
        )
        Spacer(Modifier.height(Space.two))

        pinned.forEach { message ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .defaultMinSize(minHeight = TouchTarget.recommended),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    text = pinnedPreviewLine(message, me),
                    style = MaterialTheme.typography.bodyMedium,
                    color = colors.textPrimary,
                    modifier = Modifier.weight(1f),
                )
                SwetTextButton(
                    text = stringResource(Res.string.chat_action_unpin),
                    onClick = { onUnpin(message.id) },
                )
            }
        }

        Spacer(Modifier.height(Space.two))
        SwetSecondaryButton(text = stringResource(Res.string.chat_action_close), onClick = onDismiss)
    }
}

// ---------------------------------------------------------------------------------------------
// The long-press menu -- SDS §12.5 / SPS §10.13
// ---------------------------------------------------------------------------------------------

/**
 * An entry §12.5's menu can carry on this build.
 *
 * Reply and Edit are first-class actions. Forward remains absent rather than being drawn inert:
 * there is no forwarding API or client flow yet.
 */
internal enum class MessageAction {
    /** SPS §19.5 / STA §4.8's retry, on an own message the server never accepted. */
    Retry,
    Reply,
    Edit,
    Copy,
    Forward,
    Pin,
    Unpin,
    Select,

    /**
     * Removes the message. Which KIND of removal is decided in the confirmation step: a row that
     * never reached the server is discarded locally, and anything else goes to `deleteMessage`.
     */
    Delete,
    Report,
}

/**
 * A message the server has acknowledged.
 *
 * `CacheMappers` falls an unacknowledged row's `id` back to its `client_id`, so the two being
 * equal is exactly "the server has never seen this". Every entry that names a message to the
 * server -- Report, Delete-on-the-server, Pin -- would answer 404 without this.
 */
internal fun Message.isAcknowledged(): Boolean = id.value != clientId

internal fun Message.isForwardable(): Boolean = kind in setOf(
    MessageKind.TEXT,
    MessageKind.IMAGE,
    MessageKind.VOICE,
    MessageKind.SHARED_POST,
)

/** Short-tap destinations are explicit because photo viewing and reacting must never compete. */
internal enum class MessageTapAction { None, Reactions, Media }

internal fun messageTapAction(message: Message, reactionsAvailable: Boolean): MessageTapAction = when {
    message.isDeleted -> MessageTapAction.None
    message.kind == MessageKind.IMAGE && !message.imageUrl.isNullOrBlank() -> MessageTapAction.Media
    reactionsAvailable && canShowReactionPicker(message) -> MessageTapAction.Reactions
    else -> MessageTapAction.None
}

/**
 * Which of §12.5's actions this message actually offers.
 *
 * Pure, and pulled out of the dialog for the reason the read-receipt rules were: availability
 * "may change depending on ownership, permissions, and message type" (SPS §10.13) is five
 * booleans' worth of combinations, and a wrong one is either an entry that 404s or a control the
 * user needed and could not find. This host has no device to discover either on.
 *
 * THE RULES, in order:
 *
 *  - A FAILED own message is a different object from a sent one. It offers Retry and Delete and
 *    nothing that names it to the server -- Pin in particular, because pinning a message that was
 *    never sent is meaningless, and Report, which would 404. This is the state that had NO
 *    actions at all, in a menu opened above a bubble whose only explanation was a red glyph.
 *  - Copy is offered wherever there is text to copy. It is the most-used entry in any messenger's
 *    message menu and there was no way to copy message text at all.
 *  - Pin is offered on every acknowledged message including the user's own and including incoming
 *    ones: the contract puts no ownership restriction on `pinMessage` and the server accepts a pin
 *    from any member. Already-pinned offers Unpin instead, derived from the pinned LIST -- the
 *    contract's `Message` carries no pin state, so neither does the timeline's.
 *  - Delete is offered on anything the caller can remove: `scope=self` is available to any member
 *    with no time limit, so the entry itself needs no ownership test. Whether "for everyone" may
 *    be offered is `can_delete_for_everyone`, which is the server's own answer and is carried on
 *    the row -- see [MessageActionsDialog]'s confirmation step.
 *  - Report is §12.5's one explicit placement rule: "available for messages not sent by the
 *    current user".
 *
 * A deleted message offers only Report: there is no text to copy, nothing to pin, and it is
 * already gone.
 */
internal fun messageActions(
    message: Message,
    me: UserId,
    isPinned: Boolean,
    canPin: Boolean,
    canReport: Boolean,
    canDelete: Boolean,
    canReply: Boolean = false,
    canEdit: Boolean = false,
    canForward: Boolean = false,
    canSelect: Boolean = true,
): List<MessageAction> {
    val unsent = message.isMine(me) && message.state == MessageState.FAILED
    val acknowledged = message.isAcknowledged()
    val actions = mutableListOf<MessageAction>()

    if (unsent) actions += MessageAction.Retry
    if (canReply && acknowledged && !unsent && !message.isDeleted) actions += MessageAction.Reply
    if (
        canEdit && acknowledged && message.canEdit && message.isMine(me) &&
        message.kind == MessageKind.TEXT && !message.text.isNullOrBlank() && !message.isDeleted
    ) {
        actions += MessageAction.Edit
    }
    if (!message.isDeleted && !message.text.isNullOrBlank()) actions += MessageAction.Copy
    if (canForward && acknowledged && !unsent && !message.isDeleted && message.isForwardable()) {
        actions += MessageAction.Forward
    }
    if (canPin && acknowledged && !unsent && !message.isDeleted) {
        actions += if (isPinned) MessageAction.Unpin else MessageAction.Pin
    }
    if (canSelect && !message.isDeleted) actions += MessageAction.Select
    // Destructive last, and in this order, because §12.5 requires them visually separated and a
    // finger reaching for Pin must not land on the entry that files a complaint about a person.
    if (canDelete && (unsent || acknowledged) && !message.isDeleted) actions += MessageAction.Delete
    if (canReport && acknowledged && !unsent && !message.isMine(me)) actions += MessageAction.Report

    return actions
}

/** The two entries §12.5 calls destructive, and which [ChatActionRow] therefore draws in danger. */
internal fun MessageAction.isDestructive(): Boolean =
    this == MessageAction.Delete || this == MessageAction.Report

/**
 * What each entry is CALLED, as a key rather than as words.
 *
 * A `when` over the enum rather than a label on the enum constants, so the exhaustiveness check
 * fires when an entry is added: a `MessageAction` with no case here does not compile, where a
 * nullable property would simply render nothing and leave a blank row in the sheet.
 *
 * Pure and named so a test can hold it to the one rule words cannot state: SIX ENTRIES, SIX KEYS.
 * A copy-pasted key compiles, renders real words, and passes every lint in the project while
 * putting `Pin` on the row that files a complaint about somebody.
 */
internal fun MessageAction.label(): StringResource = when (this) {
    MessageAction.Retry -> Res.string.chat_action_retry
    MessageAction.Reply -> Res.string.chat_action_reply
    MessageAction.Edit -> Res.string.chat_action_edit
    MessageAction.Copy -> Res.string.chat_action_copy
    MessageAction.Forward -> Res.string.chat_action_forward
    MessageAction.Pin -> Res.string.chat_action_pin
    MessageAction.Unpin -> Res.string.chat_action_unpin
    MessageAction.Select -> Res.string.chat_action_select
    MessageAction.Delete -> Res.string.chat_action_delete
    MessageAction.Report -> Res.string.chat_action_report
}

/** One monochrome mark per action; labels remain the accessible source of meaning. */
internal fun MessageAction.icon(): ImageVector = when (this) {
    MessageAction.Retry -> SwetIcons.Refresh
    MessageAction.Reply -> SwetIcons.Reply
    MessageAction.Edit -> SwetIcons.Pencil
    MessageAction.Copy -> SwetIcons.Copy
    MessageAction.Forward -> SwetIcons.Forward
    MessageAction.Pin, MessageAction.Unpin -> SwetIcons.Pin
    MessageAction.Select -> SwetIcons.Check
    MessageAction.Delete -> SwetIcons.Trash
    MessageAction.Report -> SwetIcons.Flag
}

/**
 * Which confirmation the Delete step asks, of the three.
 *
 * THIS IS THE HIGHEST-STAKES SENTENCE ON THE SCREEN and the reason it is a rule of its own. The two
 * scopes are different acts: `for me` hides the message on this account, `for everyone` withdraws it
 * from the conversation. A reader who cannot tell them apart either leaves standing a message they
 * meant to withdraw, or believes they withdrew one everybody can still read. Neither failure is
 * visible from the outside, and this host has no device to find them on.
 *
 * [unsent] wins over [canDeleteForEveryone] and the order is load-bearing: the server sets
 * `can_delete_for_everyone` on rows it has, and a row it has never seen carries whatever the
 * optimistic insert put there. A message that was never sent has no copy anywhere, so offering a
 * scope for it would be a distinction without a difference.
 */
internal fun deleteConfirmation(unsent: Boolean, canDeleteForEveryone: Boolean): StringResource = when {
    unsent -> Res.string.chat_delete_confirm_unsent
    canDeleteForEveryone -> Res.string.chat_delete_confirm_everyone
    else -> Res.string.chat_delete_confirm_self
}

/**
 * The label on the button that does NOT withdraw the message from the conversation.
 *
 * An unsent message exists nowhere else, so "for me" there would read as though a copy survives
 * somewhere. It is the plain word instead.
 */
internal fun deleteScopeLabel(unsent: Boolean): StringResource =
    if (unsent) Res.string.chat_action_delete else Res.string.chat_delete_for_me

/**
 * SDS §12.5's long-press menu.
 *
 * Reply, Edit, Copy, Pin, Delete and Report are drawn when their permission predicates allow them;
 * Retry is the local-only recovery action for a failed send. Forward stays out; see [MessageAction].
 *
 * DELETE CONFIRMS, and the confirmation is where the scope is chosen. SDS §11.1's Destructive
 * Button says "Use confirmation dialogs for destructive actions" -- NOT §12.2, which this file
 * cited elsewhere and which is the chat list's SWIPE actions ("Delete must require confirmation"
 * about deleting a whole conversation). The rule lands the same way here; the citation did not,
 * and a wrong one is how a rule gets argued away later.
 *
 * The two scopes are genuinely different acts rather than a fallback ladder: "for me" hides the
 * message on this device, "for everyone" withdraws it from the conversation. Offering both as
 * buttons is what makes the difference legible at the moment it matters; offering "for everyone"
 * only when the server said it would accept it is what stops the app promising something it will
 * be refused for.
 */
@Composable
private fun MessageActionsDialog(
    message: Message,
    me: UserId,
    isPinned: Boolean,
    canPin: Boolean,
    canReport: Boolean,
    canDelete: Boolean,
    canReply: Boolean,
    canEdit: Boolean,
    canForward: Boolean,
    onDismiss: () -> Unit,
    onSetPinned: (Boolean) -> Unit,
    onReply: () -> Unit,
    onEdit: () -> Unit,
    onCopy: () -> Unit,
    onForward: () -> Unit,
    onSelect: () -> Unit,
    onReact: (String) -> Unit,
    onDelete: (forEveryone: Boolean) -> Unit,
    onRetry: () -> Unit,
    onReport: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    val actions = remember(message, me, isPinned, canPin, canReport, canDelete, canReply, canEdit, canForward) {
        messageActions(
            message, me, isPinned, canPin, canReport, canDelete, canReply, canEdit,
            canForward = canForward,
        )
    }
    // Step two, local for the reason `ReportSheet` keeps its own: it is a position in a flow, not
    // a fact about the world.
    var confirmingDelete by remember { mutableStateOf(false) }
    val unsent = message.isMine(me) && message.state == MessageState.FAILED

    MessageActionDialogShell(onDismiss = onDismiss) {
        Text(
            text = pinnedPreviewLine(message, me),
            style = MaterialTheme.typography.bodyMedium,
            color = colors.textSecondary,
        )
        if (!message.isDeleted && message.isAcknowledged()) {
            ReactionPicker(onEmojiSelected = { emoji ->
                onDismiss()
                onReact(emoji)
            })
            Spacer(Modifier.height(Space.two))
        }

        if (confirmingDelete) {
            Text(
                text = stringResource(deleteConfirmation(unsent, message.canDeleteForEveryone)),
                style = MaterialTheme.typography.bodyMedium,
                color = colors.textPrimary,
            )
            Spacer(Modifier.height(Space.two))

            if (message.canDeleteForEveryone && !unsent) {
                ChatActionRow(
                    text = stringResource(Res.string.chat_delete_for_everyone),
                    onClick = { onDelete(true) },
                    destructive = true,
                )
                Spacer(Modifier.height(Space.one))
            }
            ChatActionRow(
                text = stringResource(deleteScopeLabel(unsent)),
                onClick = { onDelete(false) },
                destructive = true,
            )
        } else {
            actions.forEachIndexed { index, action ->
                if (index > 0) Spacer(Modifier.height(Space.one))
                ChatActionRow(
                    text = stringResource(action.label()),
                    onClick = {
                        when (action) {
                            MessageAction.Retry -> onRetry()
                            MessageAction.Reply -> onReply()
                            MessageAction.Edit -> onEdit()
                            MessageAction.Copy -> onCopy()
                            MessageAction.Forward -> onForward()
                            MessageAction.Pin -> onSetPinned(true)
                            MessageAction.Unpin -> onSetPinned(false)
                            MessageAction.Select -> onSelect()
                            // The one entry that does not close the sheet: §11.1's confirmation.
                            MessageAction.Delete -> confirmingDelete = true
                            MessageAction.Report -> onReport()
                        }
                    },
                    // §12.5: destructive actions are visually separated. The colour reinforces;
                    // the words already say what they are, which is §22.2's requirement.
                    destructive = action.isDestructive(),
                    icon = action.icon(),
                )
            }
        }

        Spacer(Modifier.height(Space.two))
        SwetSecondaryButton(
            // Two words for two different acts: backing out of the confirmation, and closing the
            // menu. "Cancel" on the confirmation step would read as cancelling the message.
            text = stringResource(
                if (confirmingDelete) Res.string.chat_action_keep else Res.string.chat_action_cancel,
            ),
            onClick = { if (confirmingDelete) confirmingDelete = false else onDismiss() },
        )
    }
}

/** Compact floating menu used only for a held message; other confirmation dialogs stay full-width. */
@Composable
private fun MessageActionDialogShell(
    onDismiss: () -> Unit,
    content: @Composable ColumnScope.() -> Unit,
) {
    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(usePlatformDefaultWidth = false),
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = Space.two, vertical = Space.eight),
            contentAlignment = Alignment.CenterEnd,
        ) {
            Column(
                modifier = Modifier
                    .widthIn(max = TouchTarget.recommended * 7)
                    .clip(RoundedCornerShape(Radius.xl))
                    .background(SwetgramThemeTokens.colors.surface)
                    .padding(Space.two),
                content = content,
            )
        }
    }
}

/** A tap-only reaction chooser, intentionally separate from the long-press action menu. */
/**
 * One line describing a message, for the banner and the two menus.
 *
 * Deliberately the same shape as the chat list's row preview and DECISIONS §9's push preview, so a
 * pinned photo does not read as "Sent a photo" in one place and blank in another.
 *
 * The sender is named for everything except the reader's own message, unlike the chat list -- there
 * the title already says who the conversation is with, and here the whole point of the line is to
 * identify one message among several.
 *
 * IT USED TO BE `"$speaker: $body"` AND THAT IS THE DEFECT THIS PASS EXISTS FOR. The two halves are
 * both translated, so the line was a sentence assembled out of pieces at runtime, with a colon
 * chosen in Kotlin. Worse, the speaker slot held either a display NAME or the word "You" -- and
 * Russian has no impersonal word to put in a slot shaped for a name (DECISIONS §24 forbids "Вы"),
 * so the own-message case cannot be a substitution at all. It gets its own sentence instead, and the
 * BODY travels as a nested `UiText` argument, which [com.swetdot.swetgram.ui.text.resolve] unwraps
 * before it substitutes. One sentence, one resource, in both languages.
 *
 * A blank speaker is a DELETED ACCOUNT, whose display name `Mappers.kt` empties: the line is then
 * the body alone rather than a stray colon with nothing in front of it.
 */
internal fun pinnedPreview(message: Message, me: UserId): UiText {
    val body = messagePreviewBody(message)
    val speaker = message.sender.displayName
    return when {
        message.isMine(me) -> Res.string.chat_preview_own.text(body)
        speaker.isBlank() -> body
        else -> Res.string.chat_preview_from.text(speaker, body)
    }
}

/** The content-only half used by reply/edit previews where the sender has its own line. */
internal fun messagePreviewBody(message: Message): UiText = when {
    message.isDeleted -> Res.string.chat_preview_body_deleted.text()
    message.kind == MessageKind.IMAGE -> Res.string.chat_preview_body_photo.text()
    message.kind == MessageKind.VOICE -> Res.string.chat_voice_message.text()
    message.picso != null -> Res.string.picso_shared_message.text()
    message.text.isNullOrBlank() -> Res.string.chat_preview_body_none.text()
    else -> Res.string.value_passthrough.text(message.text)
}

/**
 * [pinnedPreview], resolved and then flattened onto one line.
 *
 * THE CLIPPING HAS TO HAPPEN AFTER THE WORDS EXIST, which is why this is a second function rather
 * than something [pinnedPreview] could do itself: [singleLinePreview] collapses whitespace and cuts
 * at 120 characters, and it has to see the WHOLE line to do either -- a 4096-character body pasted
 * into a message is measured and laid out in full otherwise, on every recomposition of the sheet.
 * Splitting it this way also keeps the rule pure, so a test can name the key without a renderer.
 */
@Composable
internal fun pinnedPreviewLine(message: Message, me: UserId): String =
    singleLinePreview(pinnedPreview(message, me).resolve())

/** Owns the three message gestures while [MessageBubble] remains a rendering-only component. */
@Composable
private fun MessageRowWithActions(
    modifier: Modifier = Modifier,
    message: Message,
    me: UserId,
    members: List<User>,
    zone: TimeZone,
    onTap: ((IntRect) -> Unit)?,
    onLongPress: (() -> Unit)?,
    onSwipeReply: (() -> Unit)?,
    onReactionClick: (String) -> Unit,
    announceSender: Boolean,
    failureNote: String?,
    voicePlayback: VoicePlaybackState,
    onVoicePlaybackToggle: (Message) -> Unit,
    onVoicePlaybackSeek: (Message, Long) -> Unit,
    onVoicePlaybackSpeed: (Message) -> Unit,
    selectionMode: Boolean = false,
    selected: Boolean = false,
    onBubbleBoundsChanged: ((IntRect) -> Unit)? = null,
    reactionTarget: ReactionPickerTarget? = null,
    reactionClearance: Dp = Space.one * 0,
) {
    val bubbleAnchor = remember(message.clientId) { MessageBubbleAnchor() }
    val interaction = remember { MutableInteractionSource() }
    val colors = SwetgramThemeTokens.colors
    val haptics = LocalHapticFeedback.current
    val longPressLabel = stringResource(Res.string.chat_message_options)
    val selectionLabel = stringResource(Res.string.chat_selection_toggle)
    val tapLabel = stringResource(
        if (
            message.kind == MessageKind.IMAGE &&
            !message.imageUrl.isNullOrBlank() &&
            !message.isDeleted
        ) Res.string.chat_photo_open
        else Res.string.chat_message_react,
    )
    val density = LocalDensity.current
    val maxOffsetPx = with(density) { Space.eight.toPx() }
    val replyThresholdPx = with(density) { Space.six.toPx() }
    val swipeSettleSpec = swetTween<Float>(Motion.fast, SwetEasing.exit)
    var swipeOffsetPx by remember(message.clientId) { mutableFloatStateOf(0f) }
    val dragState = rememberDraggableState { delta ->
        swipeOffsetPx = replySwipeOffset(swipeOffsetPx, delta, maxOffsetPx)
    }

    var gestureModifier: Modifier = Modifier
    if (onSwipeReply != null) {
        gestureModifier = gestureModifier.draggable(
            state = dragState,
            orientation = Orientation.Horizontal,
            onDragStopped = {
                val shouldReply = shouldReplyAfterSwipe(swipeOffsetPx, replyThresholdPx)
                if (shouldReply) onSwipeReply()
                animate(
                    initialValue = swipeOffsetPx,
                    targetValue = 0f,
                    animationSpec = swipeSettleSpec,
                ) { value, _ -> swipeOffsetPx = value }
            },
        )
    }
    if (onTap != null || onLongPress != null) {
        gestureModifier = gestureModifier.combinedClickable(
                interactionSource = interaction,
                indication = null,
                onClickLabel = tapLabel.takeIf { onTap != null },
                onLongClickLabel = longPressLabel.takeIf { onLongPress != null },
                onLongClick = onLongPress?.let { action ->
                    {
                        haptics.performHapticFeedback(HapticFeedbackType.LongPress)
                        action()
                    }
                },
                onClick = {
                    bubbleAnchor.coordinates?.takeIf { it.isAttached }
                        ?.boundsInWindow()?.reactionBounds()?.let { onTap?.invoke(it) }
                },
        )
    }
    gestureModifier = gestureModifier.graphicsLayer { translationX = swipeOffsetPx }

    // Reserve canvas, not a card: transparent emoji must never obscure another message's text.
    Box(modifier.fillMaxWidth().padding(
        top = if (reactionTarget != null && !reactionTarget.preferBelow) reactionClearance else Space.one * 0,
        bottom = if (reactionTarget?.preferBelow == true) reactionClearance else Space.one * 0,
    )) {
        if (selectionMode) {
            Canvas(
                modifier = Modifier
                    .align(Alignment.CenterStart)
                    .padding(start = Space.one)
                    .size(Sizes.iconMedium)
                    .semantics { contentDescription = selectionLabel },
            ) {
                drawCircle(
                    color = if (selected) {
                        colors.accent
                    } else {
                        colors.textSecondary
                    },
                    style = if (selected) androidx.compose.ui.graphics.drawscope.Fill else Stroke(2f),
                )
                if (selected) {
                    drawLine(
                        color = colors.onAccent,
                        start = Offset(size.width * .28f, size.height * .52f),
                        end = Offset(size.width * .44f, size.height * .68f),
                        strokeWidth = 2.2f,
                        cap = StrokeCap.Round,
                    )
                    drawLine(
                        color = colors.onAccent,
                        start = Offset(size.width * .44f, size.height * .68f),
                        end = Offset(size.width * .74f, size.height * .34f),
                        strokeWidth = 2.2f,
                        cap = StrokeCap.Round,
                    )
                }
            }
        }
        if (onSwipeReply != null) {
            Box(
                modifier = Modifier
                    .align(Alignment.CenterStart)
                    .padding(start = Space.two)
                    .size(TouchTarget.minimum)
                    .graphicsLayer {
                        alpha = (swipeOffsetPx / replyThresholdPx).coerceIn(0f, 1f)
                    }
                    .clip(CircleShape)
                    .background(SwetgramThemeTokens.colors.card),
                contentAlignment = Alignment.Center,
            ) {
                SwetIcon(
                    icon = SwetIcons.Reply,
                    tint = SwetgramThemeTokens.colors.accent,
                    contentDescription = null,
                    size = Sizes.iconSmall,
                )
            }
        }

        MessageBubble(
            message = message,
            me = me,
            members = members,
            onReactionClick = onReactionClick,
            announceSender = announceSender,
            failureNote = failureNote,
            voicePlayback = voicePlayback,
            onVoicePlaybackToggle = onVoicePlaybackToggle,
            onVoicePlaybackSeek = onVoicePlaybackSeek,
            onVoicePlaybackSpeed = onVoicePlaybackSpeed,
            onBubblePositioned = { coordinates ->
                bubbleAnchor.coordinates = coordinates
                if (coordinates.isAttached) {
                    onBubbleBoundsChanged?.invoke(coordinates.boundsInWindow().reactionBounds())
                }
            },
            modifier = gestureModifier
                .padding(start = if (selectionMode) Space.six else Space.one * 0)
                .background(
                    if (selected) SwetgramThemeTokens.colors.card.copy(alpha = 0.42f)
                    else androidx.compose.ui.graphics.Color.Transparent,
                ),
            zone = zone,
        )
    }
}

internal fun replySwipeOffset(current: Float, delta: Float, maximum: Float): Float =
    (current + delta).coerceIn(0f, maximum.coerceAtLeast(0f))

private class MessageBubbleAnchor {
    var coordinates: LayoutCoordinates? = null
}

internal fun shouldReplyAfterSwipe(offset: Float, threshold: Float): Boolean =
    threshold > 0f && offset >= threshold

/**
 * The line under a message that did not go, or null.
 *
 * WHAT IT REPLACES. A FAILED message was a circled exclamation drawn at the size of a tick, in
 * `danger`, and nothing else -- SDS §25.1 requires an error state to "explain what happened", and
 * SPS §19.5 and STA §4.8 both require a retry ACTION, which no glyph is. The state was carried
 * entirely by colour on a 16dp mark, which §22.2 also forbids.
 *
 * [hasActions] decides whether the sentence may point at the menu. A build with no message menu
 * wired would otherwise tell the reader to long-press something that does nothing, which is worse
 * than the bare statement of fact.
 *
 * Only ever on the reader's OWN messages: an incoming message has no delivery state of ours to
 * report, and `MetaRow` already draws no tick on one.
 */
internal fun failedSendNote(message: Message, me: UserId, hasActions: Boolean): UiText? {
    if (!message.isMine(me) || message.state != MessageState.FAILED) return null
    return if (hasActions) {
        Res.string.chat_send_failed_note_retryable.text()
    } else {
        Res.string.chat_send_failed_note.text()
    }
}

/**
 * SDS §12.3: `Message @alex...`, or the group's name for a group.
 *
 * The handle is used for a DIRECT chat, which is what §12.3 and SPS §10.10 both write
 * (`Message @alex...`); a group has no handle, so it takes its name (`Message Book Club...`).
 * A blank title -- the conversation has not loaded yet -- falls back to the bare §11.2
 * placeholder rather than rendering "Message ...".
 */
internal fun composerPlaceholder(title: String, peerUsername: String? = null): UiText = when {
    // The handle and the title are two different keys rather than one with a slot, because they
    // are two different grammatical objects: a handle never inflects and a name does. See
    // `values-ru/strings_chat.xml`, where the Russian for the second one has to put the name
    // somewhere its case cannot be wrong.
    !peerUsername.isNullOrBlank() -> Res.string.chat_composer_placeholder_user.text(peerUsername)
    title.isBlank() -> Res.string.chat_composer_placeholder_plain.text()
    else -> Res.string.chat_composer_placeholder_titled.text(title)
}

/**
 * The header's status line: what somebody is doing right now, or failing that who they are.
 *
 * SDS §12.3 gives the header ONE such slot -- "Online / last seen summary" -- so typing REPLACES
 * the presence line for as long as it lasts rather than appearing beside it or below it. Nothing
 * is lost by the substitution: presence is a standing fact that is still true a second later,
 * where typing is happening now and stops on its own.
 *
 * That slot is also the only place on this screen the typing sentence appears. The SDS specifies
 * no typing row of its own, one sentence rendered in two places at once reads as a bug rather than
 * as emphasis, and the header is the part of the conversation that stays put -- legible with the
 * keyboard open, at any scroll position, which a line pinned above the composer is not.
 *
 * [presence] is very often null (see [chatSubtitle], which says nothing when there is nothing true
 * to say), and then the typing sentence is what makes the line exist at all.
 *
 * `@Composable` ONLY so that it can resolve the key [typingLabel] chooses, exactly as [chatSubtitle]
 * is and for the same reason. THE RULE IS NOT HERE: which typing sentence applies is [typingLabel]'s
 * decision, it is pure, and `TypingStateTest` asserts the KEY it picks. What is left here is the
 * substitution itself -- typing stands in for presence and hands it back -- which is the `?:` and
 * nothing more. [presence] arrives already rendered because it is `ChatScreen`'s parameter and comes
 * from outside this file; it is not copy this function chooses.
 */
@Composable
internal fun chatHeaderSubtitle(typingNames: List<String>, presence: String?): String? =
    typingLabel(typingNames).resolveOrNull() ?: presence

/**
 * The header's second line -- SDS §12.3's "online / last seen summary", SPS §10.12's
 * "group top bar shows group name and status/member count".
 *
 * The word "offline" is never printed. `User.isOnline` is a non-null Boolean that collapses
 * "hidden by a privacy setting" into `false`, so asserting it would be reporting a state the
 * server may never have sent -- `domain/UserProfile` keeps that distinction and this type does
 * not. (The public profile screen, which reads the nullable field, DOES say "Offline", and is
 * right to.)
 *
 * What it does instead of falling silent is fall back to the HANDLE. §12.3 gives the header a
 * summary line and a direct chat with nobody's presence to report was leaving it empty, which is
 * two separate defects: the slot the spec describes is blank, and the bar changes HEIGHT whenever
 * a sentence does arrive -- most visibly every time somebody starts and stops typing, since
 * [chatHeaderSubtitle] borrows this same line. `@alex` is always true, always available, and
 * identifies the person the display name above it may not (two contacts can share a name); the
 * cost is one line of chrome that was already reserved.
 *
 * Still null for a conversation that has not loaded, and for a peer this build cannot name.
 *
 * `@Composable` ONLY so that it can resolve the keys [groupChatSubtitle] and [presenceLine] choose.
 * NEITHER RULE IS HERE and neither may come back here: both are pure functions with tests, and the
 * whole of this one's remaining job is to pick which of the two applies.
 */
@Composable
internal fun chatSubtitle(
    chat: Chat?,
    me: UserId,
    now: Instant,
    zone: TimeZone = TimeZone.currentSystemDefault(),
): String? {
    if (chat == null) return null
    if (chat.kind == ChatKind.GROUP) return groupChatSubtitle(chat.members.size).resolveOrNull()
    val peer = chat.peer(me) ?: return null
    return presenceLine(peer, now, zone).resolveOrNull()
}

/**
 * What the header says about one other person, or null.
 *
 * PURE, and pulled out of [chatSubtitle] rather than left inline, for the reason the member count
 * was: it is four branches over a clock, and the wrong one is a sentence that is quietly false --
 * "Last seen yesterday" about somebody who was here an hour ago. There is no device on this host to
 * notice that on, and a composable cannot be asserted here at all.
 *
 * THE WORD "OFFLINE" IS NEVER PRINTED. `User.isOnline` is a non-null Boolean that collapses "hidden
 * by a privacy setting" into `false`, so asserting it would report a state the server may never have
 * sent. (`domain/UserProfile` keeps the distinction, and the public profile screen, which reads the
 * nullable field, DOES say "Offline".)
 *
 * WITH NO LAST-SEEN AT ALL IT FALLS BACK TO THE HANDLE, which is always true and always available,
 * and identifies the person the display name above it may not. Null is left for the one case with
 * nothing true to say: no presence, no timestamp, and a peer this build cannot even name.
 *
 * The clock and the day labels are the timeline's own ([formatClockTime], [dayLabelText]), so a time
 * never reads as 6:05 PM on one line and 18:05 on the next. Both arrive as ARGUMENTS: they are
 * rendered values, not copy, and the date format is pass 3's business rather than this sentence's.
 */
internal fun presenceLine(
    peer: User,
    now: Instant,
    zone: TimeZone = TimeZone.currentSystemDefault(),
): UiText? {
    if (peer.isOnline) return Res.string.chat_presence_online.text()
    val lastSeen = peer.lastSeenAt
        ?: return peer.username
            .takeIf { it.isNotBlank() }
            ?.let { Res.string.handle_prefixed.text(it) }
    val clock = formatClockTime(lastSeen, zone)
    // The `Weekday` branch below renders the DATE: this line disagrees with the chat list on purpose and
    // through an ARGUMENT rather than a rule of its own. The weekday form is an abbreviation --
    // «Пн», "Mon" -- and this is a SENTENCE with the day inside it: «Последний раз в сети Пн» is
    // not Russian, and would need «в понедельник», which the abbreviation cannot supply.
    // `TimeFormat.dayLabel` records the split; the chat list's column, the timeline's separators
    // and Discover's bylines take the default because all three print a BARE label.
    return when (val label = dayLabel(LocalDay.of(lastSeen, zone), now, zone)) {
        DayLabel.Today -> Res.string.chat_presence_last_seen_today.text(clock)
        DayLabel.Yesterday -> Res.string.chat_presence_last_seen_yesterday.text(clock)
        // Unreachable given the argument above, and it prints the date rather than throwing, so
        // that flipping the argument later degrades to the old sentence instead of to a crash.
        is DayLabel.Weekday -> Res.string.chat_presence_last_seen_date.text(label.day.render())
        // The date alone, with no clock: a week-old timestamp is answering "roughly when", and the
        // minute it happened at is noise. This is also why it is not one key with two arguments.
        is DayLabel.Absolute -> Res.string.chat_presence_last_seen_date.text(label.day.render())
    }
}

/**
 * The group header's member count, which is `groups/GroupViewModel.memberCountLine` and nothing
 * else.
 *
 * IT DELEGATES RATHER THAN DECIDES, and that is the entire content of this function. It used to
 * read `if (count == 1) "1 member" else "$count members"` inline in [chatSubtitle] -- correct
 * English, unusable Russian (1 участник, 2 участника, 5 участников, 21 участник), and exactly the
 * expression `UiText.Plural` says may never be written. The group DETAIL screen had already moved
 * to `group_member_count`; this header had not, so one fact about one group rendered in two
 * languages one tap apart on a Russian phone. There is no version of that which is a copy edit: two
 * spellings of a count is two rules, and only one of them can be right.
 *
 * Null rather than "0 members" for a conversation whose member list has not arrived. A group always
 * has at least one member (the contract's `minimum: 1`, which holds because an owner can never
 * leave), so a zero here is an unloaded list and not a fact about the group -- and the header draws
 * a single title line rather than asserting it.
 */
internal fun groupChatSubtitle(memberCount: Int): UiText? =
    if (memberCount <= 0) null else memberCountLine(memberCount)

/**
 * The timeline's day separator.
 *
 * IT OWNS NO WORDS, and that is the fix rather than the style. This composable used to carry its own
 * `when` over [DayLabel] printing "Today" and "Yesterday" as literals, while [dayLabelText] carried a
 * second `when` over the same type reaching `chat_day_today` and `chat_day_yesterday`. Two rules over
 * one type is one rule too many: pass 2 localised the copy in [dayLabelText] and this one went on
 * printing English, so a Russian phone drew Сегодня on the last-seen line and Today on the separator
 * three pixels above it. The duplicate is deleted rather than translated -- translating it would have
 * left the same defect intact and merely harder to see.
 *
 * THE PILL IS GONE. The app drew the label on a `card`-coloured capsule; the mockup draws centred
 * grey text on the canvas and nothing else. On a pure-black canvas the capsule was also the second
 * `#222222` rounded rectangle in a column of `#222222` rounded rectangles, which made a date read
 * as a very short message from nobody.
 *
 * IT NOW SAYS «Пн», AND THAT WAS A DECISION RATHER THAN A SIDE EFFECT. Owning no words means this
 * separator inherited the weekday form the moment [dayLabel] learned it, so the question had to be
 * asked deliberately: is a separator saying «Пн» in the middle of a long timeline worse than a
 * date? It is not, for two reasons. The window is capped so a weekday name can only ever mean ONE
 * date -- seven days ago is a date, not a name (see [dayLabel]) -- so nothing here is ambiguous.
 * And the alternative is the defect this pass exists to remove: a chat list row reading «Пн»
 * opening onto a separator reading «03.08.2026», two date formats one tap apart. The separator, the
 * row and Discover's byline all take the default; only the SENTENCES opt out.
 */
@Composable
private fun DaySeparatorRow(label: DayLabel) {
    val chat = SwetgramThemeTokens.chat
    Box(
        modifier = Modifier.fillMaxWidth().padding(vertical = Space.two),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = label.dayLabelText().resolve(),
            // 13sp, which is the mockup's "roughly 13sp" and §5.3's `label` slot. The pill's label
            // was 12sp; without a background behind it the date needs the extra point.
            style = MaterialTheme.typography.labelMedium,
            color = chat.daySeparatorText,
        )
    }
}

/**
 * The input area: a "+" disc, a pill, and a send disc that appears when there is something to send.
 *
 * THE TWO GLYPHS THE MOCKUP PUTS INSIDE THE PILL ARE NOT DRAWN, and neither omission is an
 * oversight.
 *
 *  - THE MICROPHONE is now the hold-to-record control when the draft is empty. Drag left cancels;
 *    drag up locks the recording so the finger may be released.
 *  - THE SMILEY. There is no emoji picker in this app, and the system keyboard on both platforms
 *    already carries one. A glyph that opens the keyboard the user is already looking at is an
 *    invitation to press it once and never again.
 *
 * WHAT THE PLACEHOLDER SAYS IS NOT THE MOCKUP'S SENTENCE, and that one IS a deliberate refusal
 * rather than a gap. The mockup reads «Напишите сообщение...», which is a second-person plural
 * imperative -- it addresses the reader as вы. DECISIONS.md §24 forbids exactly that, and
 * `CopyLintTest.theRussianCopyUsesNoSecondPersonImperative` fails the build on the `-ите` ending, so
 * the string could not ship as written. The pill's SHAPE is the mockup's; its words stay
 * [composerPlaceholder]'s, which SDS §12.3 and SPS §10.10 both specify as `Message @alex...` and
 * whose Russian is already impersonal.
 */
@Composable
private fun Composer(
    placeholder: String,
    replyingTo: Message?,
    onCancelReply: () -> Unit,
    editingMessage: Message?,
    onCancelEdit: () -> Unit,
    onSaveEdit: (String) -> Unit,
    onSend: (String) -> Unit,
    onDraftChanged: (String) -> Unit,
    onAttachImage: (() -> Unit)?,
    attachmentInFlight: Boolean,
    voice: VoiceComposerState,
    onVoiceStart: (() -> Unit)?,
    onVoiceRelease: () -> Unit,
    onVoiceLock: () -> Unit,
    onVoiceCancel: () -> Unit,
    onVoicePauseResume: () -> Unit,
    onVoiceSend: () -> Unit,
    me: UserId,
) {
    // `rememberSaveable`, and it is the FIRST real call site in `:shared` -- see the note in
    // `ui/moderation/ReportSheet.kt`, which was accurate when it was written and is now out of
    // date by exactly this line. A String needs no custom saver on any Compose Multiplatform
    // target, so unlike that sheet's enum there is nothing to weigh: `androidApp`'s manifest
    // declares no `configChanges`, so rotating the phone recreated the Activity and silently
    // threw away whatever the user had typed. `configChanges` would hide the symptom and leave
    // process death broken.
    var draft by rememberSaveable { mutableStateOf("") }
    var editDraft by rememberSaveable(editingMessage?.clientId) {
        mutableStateOf(editingMessage?.text.orEmpty())
    }
    LaunchedEffect(editingMessage?.clientId) {
        // Editing an old message is not composing a new one. Stop the typing signal while the edit
        // owns the field, then restore it if a preserved ordinary draft returns after save/cancel.
        onDraftChanged(if (editingMessage == null) draft else "")
    }
    val activeDraft = if (editingMessage != null) editDraft else draft
    val canSend = activeDraft.isNotBlank()
    val colors = SwetgramThemeTokens.colors

    // The composer shares the canvas: the mockup has one black field from the status bar to the
    // gesture bar, with the pill and the "+" disc as the only lighter shapes on it.
    Surface(color = SwetgramThemeTokens.chat.canvas) {
        Column {
            Column(
                modifier = Modifier.animateContentSize(
                    animationSpec = swetTween(Motion.fast, SwetEasing.enter),
                ),
            ) {
                when {
                    editingMessage != null -> EditPreview(
                        message = editingMessage,
                        onCancel = onCancelEdit,
                    )
                    replyingTo != null -> ReplyPreview(
                        message = replyingTo,
                        me = me,
                        onCancel = onCancelReply,
                    )
                }
            }

            // Keep the ordinary composer (and, crucially, the microphone pointer target) alive
            // for the complete press gesture. Replacing it as soon as recording starts disposes
            // the pointerInput coroutine before the finger is released and turns a real hold into
            // a sub-second recording. The dedicated controls are only needed after lock, or while
            // an already-finished recording is uploading.
            val dedicatedVoiceComposer = usesDedicatedVoiceComposer(voice)
            Box {
                if (dedicatedVoiceComposer) {
                    VoiceRecordingComposer(
                        state = voice,
                        onCancel = onVoiceCancel,
                        onPauseResume = onVoicePauseResume,
                        onSend = onVoiceSend,
                    )
                } else {
                    Row(
                modifier = Modifier
                    .fillMaxWidth()
                    // Lifts the composer above the keyboard and the gesture bar. Without these the
                    // input sits under the keyboard, which is unusable and only shows up on device.
                    // They are correct only because nothing above this screen consumes the bottom
                    // inset -- see the frame in `ui/Navigation.kt`, which hides the bottom nav here
                    // rather than padding the conversation away from the edge twice.
                    .imePadding()
                    .navigationBarsPadding()
                    // The side insets, for the reason the timeline applies them. Chained AFTER
                    // `navigationBarsPadding`, which consumes what it applies, so a landscape
                    // navigation bar is padded for once rather than twice -- what is left here is
                    // whatever a display cutout adds beyond it.
                    .windowInsetsPadding(WindowInsets.safeDrawing.only(WindowInsetsSides.Horizontal))
                    .padding(horizontal = Space.two, vertical = Space.one),
                verticalAlignment = Alignment.Bottom,
                horizontalArrangement = Arrangement.spacedBy(Space.one),
                    ) {
                // Only when a chooser exists. A button that opens nothing is worse than no button:
                // it teaches the user the feature is broken rather than absent.
                if (onAttachImage != null) {
                    AttachButton(enabled = !attachmentInFlight, onClick = onAttachImage)
                }

                Box(
                    modifier = Modifier
                        .weight(1f)
                        // §6.3's 48dp comfortable target as a MINIMUM, not a size: the composer grows
                        // with a long draft instead of scrolling one line under the reader's thumb.
                        .defaultMinSize(minHeight = TouchTarget.recommended)
                        // A PILL, not §7.1's `radius.lg`: the mockup's input is fully rounded, and at
                        // 48dp a 20dp corner reads as a rounded box rather than a pill.
                        .clip(RoundedCornerShape(Radius.xl))
                        .background(colors.card)
                        .padding(horizontal = Space.two, vertical = Space.one + Space.half),
                    contentAlignment = Alignment.CenterStart,
                ) {
                    if (voice.active || voice.requestingPermission) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Box(Modifier.size(Space.one).clip(CircleShape).background(colors.danger))
                            Spacer(Modifier.width(Space.one))
                            Text(
                                text = formatVoiceDuration(voice.elapsedMs),
                                style = MaterialTheme.typography.labelMedium,
                                color = colors.textPrimary,
                            )
                            Spacer(Modifier.width(Space.one))
                            VoiceLiveWaveform(voice.waveform, Modifier.weight(1f).height(Sizes.iconMedium))
                            Spacer(Modifier.width(Space.one))
                            Text(
                                text = stringResource(Res.string.chat_voice_slide_cancel),
                                style = MaterialTheme.typography.labelSmall,
                                color = colors.textSecondary,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                            )
                        }
                    } else {
                        if (activeDraft.isEmpty()) {
                            Text(
                                text = if (editingMessage == null) {
                                    placeholder
                                } else {
                                    stringResource(Res.string.chat_editing_message)
                                },
                                style = MaterialTheme.typography.bodyMedium,
                                color = colors.textTertiary,
                            )
                        }
                        SwetBasicTextField(
                            value = activeDraft,
                            onValueChange = {
                                if (it.length <= MAX_MESSAGE_LENGTH) {
                                    if (editingMessage == null) {
                                        draft = it
                                        onDraftChanged(it)
                                    } else {
                                        editDraft = it
                                    }
                                }
                            },
                            textStyle = MaterialTheme.typography.bodyMedium.copy(color = colors.textPrimary),
                            cursorBrush = SolidColor(colors.accent),
                            maxLines = 5,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                }

                // Send and microphone share one fixed action slot. Their enter/exit animations
                // overlap inside this Box instead of occupying two places in the Row for 150 ms.
                if (canSend || (editingMessage == null && onVoiceStart != null)) {
                    ComposerActionSlot(
                        canSend = canSend,
                        sendDescription = stringResource(
                            if (editingMessage == null) Res.string.chat_send else Res.string.chat_edit_save,
                        ),
                        onSend = {
                            val text = activeDraft.trim()
                            if (text.isNotEmpty()) {
                                if (editingMessage == null) {
                                    onSend(text)
                                    draft = ""
                                } else {
                                    onSaveEdit(text)
                                    editDraft = ""
                                }
                            }
                        },
                        onVoiceStart = onVoiceStart.takeIf { editingMessage == null },
                        onVoiceRelease = onVoiceRelease,
                        onVoiceLock = onVoiceLock,
                        onVoiceCancel = onVoiceCancel,
                    )
                }
                    }
                }
            }
        }
    }
}

@Composable
private fun ComposerActionSlot(
    canSend: Boolean,
    sendDescription: String,
    onSend: () -> Unit,
    onVoiceStart: (() -> Unit)?,
    onVoiceRelease: () -> Unit,
    onVoiceLock: () -> Unit,
    onVoiceCancel: () -> Unit,
) {
    Box(
        modifier = Modifier.size(TouchTarget.recommended),
        contentAlignment = Alignment.Center,
    ) {
        when {
            canSend -> SwetSendButton(
                contentDescription = sendDescription,
                onClick = onSend,
            )
            onVoiceStart != null -> VoiceHoldButton(
                    onStart = onVoiceStart,
                    onRelease = onVoiceRelease,
                    onLock = onVoiceLock,
                    onCancel = onVoiceCancel,
                )
        }
    }
}

@Composable
private fun VoiceHoldButton(
    onStart: () -> Unit,
    onRelease: () -> Unit,
    onLock: () -> Unit,
    onCancel: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    val threshold = with(LocalDensity.current) { TouchTarget.minimum.toPx() * 1.5f }
    val label = stringResource(Res.string.chat_voice_record)
    // Lambdas passed from ChatScreen are recreated as its recording state changes. Reading their
    // latest values without using them as pointerInput keys keeps the active gesture coroutine
    // alive while the timer/amplitude recomposes the composer.
    val currentOnStart by rememberUpdatedState(onStart)
    val currentOnRelease by rememberUpdatedState(onRelease)
    val currentOnLock by rememberUpdatedState(onLock)
    val currentOnCancel by rememberUpdatedState(onCancel)
    Box(
        modifier = Modifier
            .size(TouchTarget.recommended)
            .clip(CircleShape)
            .background(colors.accent)
            .semantics { contentDescription = label }
            .pointerInput(Unit) {
                awaitEachGesture {
                    val down = awaitFirstDown(requireUnconsumed = false)
                    currentOnStart()
                    var cancelled = false
                    var locked = false
                    while (true) {
                        val event = awaitPointerEvent()
                        val change = event.changes.firstOrNull() ?: break
                        val displacement = change.position - down.position
                        when {
                            displacement.x <= -threshold -> cancelled = true
                            displacement.y <= -threshold -> locked = true
                        }
                        change.consume()
                        if (!change.pressed) break
                    }
                    when {
                        cancelled -> currentOnCancel()
                        locked -> currentOnLock()
                        else -> currentOnRelease()
                    }
                }
            },
        contentAlignment = Alignment.Center,
    ) {
        SwetIcon(
            icon = SwetIcons.Mic,
            tint = colors.onAccent,
            contentDescription = null,
            size = Sizes.iconMedium,
        )
    }
}

@Composable
private fun VoiceRecordingComposer(
    state: VoiceComposerState,
    onCancel: () -> Unit,
    onPauseResume: () -> Unit,
    onSend: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    val mode = voiceComposerMode(state)
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .imePadding()
            .navigationBarsPadding()
            .windowInsetsPadding(WindowInsets.safeDrawing.only(WindowInsetsSides.Horizontal))
            .padding(horizontal = Space.two, vertical = Space.one),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(Space.one),
    ) {
        SwetIconButton(
            contentDescription = stringResource(Res.string.chat_voice_delete),
            onClick = onCancel,
        ) { tint ->
            SwetIcon(icon = SwetIcons.Trash, tint = tint, contentDescription = null, size = Sizes.iconSmall)
        }

        Row(
            modifier = Modifier
                .weight(1f)
                .defaultMinSize(minHeight = TouchTarget.recommended)
                .clip(RoundedCornerShape(Radius.full))
                .background(colors.card)
                .padding(horizontal = Space.two),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Box(Modifier.size(Space.one).clip(CircleShape).background(colors.danger))
            Spacer(Modifier.width(Space.one))
            Text(
                text = formatVoiceDuration(state.elapsedMs),
                style = MaterialTheme.typography.labelMedium,
                color = colors.textPrimary,
            )
            Spacer(Modifier.width(Space.one))
            VoiceLiveWaveform(state.waveform, Modifier.weight(1f).height(Sizes.iconMedium))
            Spacer(Modifier.width(Space.one))
            Text(
                text = when (mode) {
                    VoiceComposerMode.Uploading -> stringResource(Res.string.chat_voice_uploading)
                    VoiceComposerMode.Retry -> stringResource(Res.string.chat_voice_retry)
                    VoiceComposerMode.RequestingPermission,
                    VoiceComposerMode.Locked,
                    VoiceComposerMode.Paused -> stringResource(Res.string.chat_voice_recording)
                    VoiceComposerMode.Holding -> stringResource(Res.string.chat_voice_slide_cancel)
                    VoiceComposerMode.Idle -> stringResource(Res.string.chat_voice_recording)
                },
                style = MaterialTheme.typography.labelSmall,
                color = colors.textSecondary,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }

        if (mode == VoiceComposerMode.Locked || mode == VoiceComposerMode.Paused || mode == VoiceComposerMode.Retry) {
            if (mode != VoiceComposerMode.Retry) {
                SwetIconButton(
                    contentDescription = stringResource(
                        if (state.paused) Res.string.chat_voice_resume else Res.string.chat_voice_pause,
                    ),
                    onClick = onPauseResume,
                ) { tint ->
                    SwetIcon(
                        icon = if (state.paused) SwetIcons.Play else SwetIcons.Pause,
                        tint = tint,
                        contentDescription = null,
                        size = Sizes.iconSmall,
                    )
                }
            }
            SwetSendButton(
                contentDescription = stringResource(Res.string.chat_voice_send),
                onClick = onSend,
            )
        } else if (mode != VoiceComposerMode.Uploading) {
            SwetIcon(
                icon = SwetIcons.Lock,
                tint = colors.textSecondary,
                contentDescription = stringResource(Res.string.chat_voice_slide_lock),
                size = Sizes.iconSmall,
            )
        } else {
            CircularProgressIndicator(
                modifier = Modifier.size(Sizes.iconMedium),
                color = colors.accent,
                strokeWidth = Sizes.borderHairline * 2,
            )
        }
    }
}

@Composable
private fun VoiceLiveWaveform(samples: List<Int>, modifier: Modifier = Modifier) {
    val color = SwetgramThemeTokens.colors.accent
    Canvas(modifier) {
        val availableBars = 48
        val visible = samples.takeLast(availableBars)
        val slot = size.width / availableBars
        val stroke = (slot * 0.48f).coerceAtLeast(1f)
        visible.forEachIndexed { index, sample ->
            // A small floor keeps silence visible, while every height above it is the measured
            // microphone envelope. There is no synthetic phase/pattern mixed into the signal.
            val level = (0.12f + sample.coerceIn(0, 100) / 100f * 0.88f)
                .coerceIn(0.12f, 1f)
            val x = slot / 2f + index * slot
            val half = size.height * level / 2f
            drawLine(color, Offset(x, size.height / 2f - half), Offset(x, size.height / 2f + half),
                strokeWidth = stroke, cap = StrokeCap.Round)
        }
    }
}

internal fun formatVoiceDuration(durationMs: Long): String {
    val totalSeconds = (durationMs.coerceAtLeast(0) / 1_000).coerceAtMost(120)
    return "${totalSeconds / 60}:${(totalSeconds % 60).toString().padStart(2, '0')}"
}

/**
 * A held recording deliberately stays in the ordinary composer so its microphone pointer target
 * cannot be disposed in the middle of the gesture. Only post-gesture states use the full controls.
 */
internal fun usesDedicatedVoiceComposer(state: VoiceComposerState): Boolean = when (voiceComposerMode(state)) {
    VoiceComposerMode.Locked,
    VoiceComposerMode.Paused,
    VoiceComposerMode.Uploading,
    VoiceComposerMode.Retry -> true
    VoiceComposerMode.Idle,
    VoiceComposerMode.RequestingPermission,
    VoiceComposerMode.Holding -> false
}

@Composable
private fun EditPreview(message: Message, onCancel: () -> Unit) {
    val colors = SwetgramThemeTokens.colors
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = Space.two, vertical = Space.one),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Box(
            Modifier
                .width(Sizes.borderHairline * 2)
                .height(Sizes.iconLarge)
                .background(colors.accent),
        )
        Spacer(Modifier.width(Space.one + Space.half))
        SwetIcon(
            icon = SwetIcons.Pencil,
            tint = colors.accent,
            contentDescription = null,
            size = Sizes.iconSmall,
        )
        Spacer(Modifier.width(Space.one))
        Column(Modifier.weight(1f)) {
            Text(
                text = stringResource(Res.string.chat_editing_message),
                style = MaterialTheme.typography.labelMedium,
                color = colors.accent,
                maxLines = 1,
            )
            Text(
                text = message.text.orEmpty(),
                style = MaterialTheme.typography.bodySmall,
                color = colors.textSecondary,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }
        SwetIconButton(
            contentDescription = stringResource(Res.string.chat_action_cancel),
            onClick = onCancel,
        ) { tint ->
            SwetIcon(icon = SwetIcons.Close, tint = tint, contentDescription = null, size = Sizes.iconSmall)
        }
    }
}

/**
 * A preview of the message being replied to, shown in the composer.
 */
@Composable
private fun ReplyPreview(
    message: Message,
    me: UserId,
    onCancel: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = Space.two, vertical = Space.one),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        // Vertical accent bar
        Box(
            Modifier
                .width(Sizes.borderHairline * 2)
                .height(Sizes.iconLarge)
                .background(colors.accent),
        )
        Spacer(Modifier.width(Space.one + Space.half))

        Column(Modifier.weight(1f)) {
            Text(
                text = if (message.isMine(me)) {
                    stringResource(Res.string.chat_preview_own_title)
                } else {
                    message.sender.displayName
                },
                style = MaterialTheme.typography.labelMedium,
                color = colors.accent,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
            Text(
                text = singleLinePreview(messagePreviewBody(message).resolve()),
                style = MaterialTheme.typography.bodySmall,
                color = colors.textSecondary,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }

        SwetIconButton(
            contentDescription = stringResource(Res.string.chat_action_cancel),
            onClick = onCancel,
        ) { tint ->
            SwetIcon(icon = SwetIcons.Close, tint = tint, contentDescription = null, size = Sizes.iconSmall)
        }
    }
}

/** Header shown while one or more timeline rows are selected. */
@Composable
private fun MessageSelectionHeader(
    count: Int,
    canCopy: Boolean,
    canForward: Boolean,
    canDelete: Boolean,
    onClose: () -> Unit,
    onCopy: () -> Unit,
    onForward: () -> Unit,
    onDelete: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    Column(Modifier.background(SwetgramThemeTokens.chat.canvas)) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(ChatHeaderHeight)
                .padding(horizontal = Space.half),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            SwetIconButton(
                contentDescription = stringResource(Res.string.chat_selection_close),
                onClick = onClose,
            ) { tint -> SwetIcon(SwetIcons.Close, tint, null) }
            Text(
                text = stringResource(Res.string.chat_selected_count, count),
                style = MaterialTheme.typography.titleMedium,
                color = colors.textPrimary,
                modifier = Modifier
                    .weight(1f)
                    .semantics { liveRegion = LiveRegionMode.Polite },
            )
            SwetIconButton(
                contentDescription = stringResource(Res.string.chat_action_copy),
                onClick = onCopy,
                enabled = canCopy,
            ) { tint -> SwetIcon(SwetIcons.Copy, tint, null) }
            SwetIconButton(
                contentDescription = stringResource(Res.string.chat_action_forward),
                onClick = onForward,
                enabled = canForward,
            ) { tint -> SwetIcon(SwetIcons.Forward, tint, null) }
            SwetIconButton(
                contentDescription = stringResource(Res.string.chat_action_delete),
                onClick = onDelete,
                enabled = canDelete,
            ) { tint -> SwetIcon(SwetIcons.Trash, tint, null) }
        }
        HorizontalDivider(color = colors.border)
    }
}

/** Bottom action pair mirrors the thumb-reachable controls of the supplied reference. */
@Composable
private fun MessageSelectionBottomBar(
    canReply: Boolean,
    canForward: Boolean,
    onReply: () -> Unit,
    onForward: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    Surface(color = colors.surface) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .navigationBarsPadding()
                .padding(horizontal = Space.two, vertical = Space.one),
            horizontalArrangement = Arrangement.spacedBy(Space.one),
        ) {
            SelectionActionButton(
                label = stringResource(Res.string.chat_action_reply),
                icon = SwetIcons.Reply,
                enabled = canReply,
                onClick = onReply,
                modifier = Modifier.weight(1f),
            )
            SelectionActionButton(
                label = stringResource(Res.string.chat_action_forward),
                icon = SwetIcons.Forward,
                enabled = canForward,
                onClick = onForward,
                modifier = Modifier.weight(1f),
            )
        }
    }
}

@Composable
private fun SelectionActionButton(
    label: String,
    icon: ImageVector,
    enabled: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val colors = SwetgramThemeTokens.colors
    val tint = if (enabled) colors.textPrimary else colors.textTertiary
    Row(
        modifier = modifier
            .clip(RoundedCornerShape(Radius.full))
            .background(colors.card)
            .swetPressable(onClick = onClick, enabled = enabled)
            .defaultMinSize(minHeight = TouchTarget.recommended)
            .padding(horizontal = Space.two),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center,
    ) {
        SwetIcon(icon, tint, null, size = Sizes.iconSmallMedium)
        Spacer(Modifier.width(Space.one))
        Text(label, style = MaterialTheme.typography.labelLarge, color = tint)
    }
}

@Composable
private fun ForwardMessagesDialog(
    chats: List<Chat>,
    me: UserId,
    onDismiss: () -> Unit,
    onTarget: (Chat) -> Unit,
) {
    var query by remember { mutableStateOf("") }
    val filtered = remember(chats, query) {
        chats.filter { it.displayTitle(me).contains(query.trim(), ignoreCase = true) }
    }
    ChatDialog(onDismiss = onDismiss) {
        Text(
            text = stringResource(Res.string.chat_forward_title),
            style = MaterialTheme.typography.titleLarge,
            color = SwetgramThemeTokens.colors.textPrimary,
        )
        Spacer(Modifier.height(Space.two))
        SwetBasicTextField(
            value = query,
            onValueChange = { query = it },
            singleLine = true,
            textStyle = MaterialTheme.typography.bodyMedium.copy(
                color = SwetgramThemeTokens.colors.textPrimary,
            ),
            cursorBrush = SolidColor(SwetgramThemeTokens.colors.accent),
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(Radius.lg))
                .background(SwetgramThemeTokens.colors.card)
                .defaultMinSize(minHeight = TouchTarget.recommended)
                .padding(horizontal = Space.two, vertical = Space.one),
            decorationBox = { inner ->
                Box(contentAlignment = Alignment.CenterStart) {
                    if (query.isBlank()) {
                        Text(
                            stringResource(Res.string.chat_forward_search),
                            color = SwetgramThemeTokens.colors.textSecondary,
                            style = MaterialTheme.typography.bodyMedium,
                        )
                    }
                    inner()
                }
            },
        )
        Spacer(Modifier.height(Space.one))
        if (filtered.isEmpty()) {
            Text(
                stringResource(Res.string.chat_forward_empty),
                color = SwetgramThemeTokens.colors.textSecondary,
                style = MaterialTheme.typography.bodyMedium,
                modifier = Modifier.padding(vertical = Space.three),
            )
        } else {
            LazyColumn(Modifier.fillMaxWidth().heightIn(max = TouchTarget.recommended * 7)) {
                items(filtered.size, key = { filtered[it].id.value }) { index ->
                    val chat = filtered[index]
                    ChatActionRow(
                        text = chat.displayTitle(me),
                        onClick = { onTarget(chat) },
                        icon = SwetIcons.ChatNavigation,
                    )
                }
            }
        }
        Spacer(Modifier.height(Space.one))
        SwetSecondaryButton(
            text = stringResource(Res.string.chat_action_cancel),
            onClick = onDismiss,
        )
    }
}

@Composable
private fun DeleteSelectedMessagesDialog(
    canDeleteForEveryone: Boolean,
    onDismiss: () -> Unit,
    onDelete: (Boolean) -> Unit,
) {
    ChatDialog(onDismiss = onDismiss) {
        Text(
            text = stringResource(Res.string.chat_delete_selected_confirm),
            style = MaterialTheme.typography.bodyLarge,
            color = SwetgramThemeTokens.colors.textPrimary,
        )
        Spacer(Modifier.height(Space.two))
        if (canDeleteForEveryone) {
            ChatActionRow(
                text = stringResource(Res.string.chat_delete_for_everyone),
                onClick = { onDelete(true) },
                destructive = true,
                icon = SwetIcons.Trash,
            )
        }
        ChatActionRow(
            text = stringResource(Res.string.chat_delete_for_me),
            onClick = { onDelete(false) },
            destructive = true,
            icon = SwetIcons.Trash,
        )
        Spacer(Modifier.height(Space.one))
        SwetSecondaryButton(
            text = stringResource(Res.string.chat_action_cancel),
            onClick = onDismiss,
        )
    }
}

/**
 * The conversation header.
 *
 * HAND-BUILT RATHER THAN [SwetTopAppBar], which it used to be, and the reason is the avatar. SDS
 * §11.7's bar has one leading slot and it belongs to the back button, so the peer's disc was being
 * drawn in the TRAILING slot -- name on the left, face on the far right. The mockup puts it where
 * every messenger puts it: chevron, then face, then a two-line identity block. That is a second
 * leading slot, and adding one to a design-system component this screen does not own would change
 * every other bar in the app.
 *
 * What it keeps from §11.7 is everything else: the same 56dp height, the same hairline divider, the
 * same title and subtitle roles. It sits on the canvas rather than on `surface`, because the mockup
 * has the header share the black field with the timeline and puts a single hairline between them.
 *
 * TAPPING THE IDENTITY BLOCK OPENS THE PROFILE, as it did when the whole bar was tappable. The
 * target is narrowed to the avatar and the name so that the trailing glyphs keep their own presses
 * and so a screen reader hears one action rather than an entire bar that is somehow a button.
 */
@Composable
private fun ChatHeader(
    title: String,
    subtitle: String?,
    isOnline: Boolean,
    avatarUrl: String?,
    hasBlackBadge: Boolean,
    onBack: () -> Unit,
    peerUsername: String?,
    onOpenProfile: (String) -> Unit,
    announceSubtitle: Boolean,
    onRefresh: (() -> Unit)?,
    refreshing: Boolean,
) {
    val colors = SwetgramThemeTokens.colors
    val chat = SwetgramThemeTokens.chat
    val openProfileLabel = stringResource(Res.string.chat_open_profile)

    Column(Modifier.background(chat.canvas)) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(ChatHeaderHeight)
                // The 4dp that puts a 44dp icon button's glyph on the same optical line as a 16dp
                // margin, exactly as SwetTopAppBar insets itself.
                .padding(horizontal = Space.half),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            SwetIconButton(
                contentDescription = stringResource(Res.string.chat_back),
                onClick = onBack,
            ) { tint ->
                SwetIcon(icon = SwetIcons.ChevronLeft, tint = tint, contentDescription = null)
            }

            Row(
                modifier = Modifier
                    .weight(1f)
                    // THE WHOLE BAR HEIGHT, not the height of the text in it. Without this the
                    // clickable Row is as tall as its tallest child -- `titleMedium`'s 24sp plus
                    // `labelMedium`'s 18sp is 42dp, and 36dp when there is no presence line at all
                    // -- both under §6.3's 44dp minimum, on a screen where every other target is
                    // pinned to `TouchTarget`. The bar is already fixed at [ChatHeaderHeight], so
                    // filling it costs nothing and puts the target back where it was when the whole
                    // app bar carried the gesture.
                    .fillMaxHeight()
                    .then(
                        if (peerUsername == null) {
                            Modifier
                        } else {
                            // `swetPressable`, not `clickable`: SwetgramTheme installs
                            // MaterialTheme, so `LocalIndication` is populated and a bare
                            // `clickable` inherits Material's ripple -- an expanding circle at
                            // Material's duration rather than §19.2's.
                            Modifier.swetPressable(
                                onClickLabel = openProfileLabel,
                                onClick = { onOpenProfile(peerUsername) },
                            )
                        },
                    )
                    .then(
                        // §22.4: a screen reader has to be TOLD somebody started typing, because
                        // nothing was focused and nothing was tapped -- the sentence simply
                        // arrived. Polite rather than Assertive so it waits for the reader to
                        // finish the message they were on.
                        //
                        // Applied only WHILE somebody is typing. A permanent live region here
                        // would also announce every presence change, which is chatter over a
                        // screen the user is trying to read.
                        if (announceSubtitle) {
                            Modifier.semantics { liveRegion = LiveRegionMode.Polite }
                        } else {
                            Modifier
                        },
                    )
                    .padding(horizontal = Space.half),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                // Blank until the conversation loads: an avatar built from an empty name is a grey
                // disc with nothing in it, which reads as a broken image rather than as loading.
                if (title.isNotBlank()) {
                    SwetAvatar(
                        displayName = title,
                        size = Sizes.avatarChatHeader,
                        isOnline = isOnline,
                        // §11.5: the dot's 2dp border takes the colour of what it sits ON, and this
                        // bar is now the canvas rather than `surface`.
                        surfaceColor = chat.canvas,
                        avatarUrl = avatarUrl,
                        // Decorative: the line under the name already reads "Online" when the dot is
                        // lit, and describing both says it twice.
                        onlineContentDescription = null,
                    )
                    Spacer(Modifier.width(Space.one + Space.half))
                }

                Column(Modifier.weight(1f)) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(
                            text = title,
                            style = MaterialTheme.typography.titleMedium,
                            color = colors.textPrimary,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            modifier = Modifier.weight(1f, fill = false),
                        )
                        if (hasBlackBadge) {
                            Spacer(Modifier.width(Space.half))
                            SwetBlackBadge()
                        }
                    }
                    Crossfade(
                        targetState = subtitle,
                        animationSpec = swetTween(Motion.fast, SwetEasing.enter),
                        label = "chatHeaderSubtitle",
                    ) { visibleSubtitle ->
                        if (visibleSubtitle != null) {
                            Text(
                                text = visibleSubtitle,
                                // 13sp, which is what the mockup reads for the presence line.
                                style = MaterialTheme.typography.labelMedium,
                                color = colors.textSecondary,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier.swetTransitionTarget(visibleSubtitle == subtitle),
                            )
                        }
                    }
                }
            }

            /*
             * THE TELEPHONE IS NOT DRAWN, AND ITS SLOT IS LEFT EMPTY.
             *
             * The mockup has two glyphs here, a telephone and an ⓘ. This app has no calling: the
             * frozen contract declares no call operation, no signalling frame exists on the socket,
             * and nothing in `:shared` could place one. A control that does nothing is the defect
             * this codebase has spent the week removing, so the slot stays empty rather than being
             * filled with something else that happens to fit.
             *
             * REFRESH IS THE ONE THING HERE THE MOCKUP DOES NOT SHOW, and it is not standing in for
             * the telephone -- it is drawn before the ⓘ, which keeps the trailing position the
             * mockup gives it. It is kept because dropping it would remove the only manual recovery
             * a POPULATED conversation has: the socket's `runLoop` swallows failures and backs off
             * to a 30-second cap, so a dead socket renders exactly like a healthy one and simply
             * stops receiving; pull-to-refresh cannot transfer to a `reverseLayout` timeline
             * (DECISIONS §22); and §22.4 needs an action a screen reader can focus and a switch can
             * activate, which a gesture is not. If it should go, deleting this block is the whole
             * change and the pull-to-refresh on the empty states is unaffected.
             */
            if (onRefresh != null) {
                SwetIconButton(
                    // Two descriptions rather than one plus a disabled state: a control announced
                    // as "Refresh" that does nothing when activated tells a screen reader nothing
                    // about why.
                    contentDescription = stringResource(
                        if (refreshing) Res.string.chat_refreshing else Res.string.chat_refresh,
                    ),
                    onClick = onRefresh,
                    enabled = !refreshing,
                ) { tint ->
                    if (refreshing) {
                        CircularProgressIndicator(
                            modifier = Modifier.size(Sizes.iconMedium),
                            // §4.8: one accent, named rather than defaulted through the derived
                            // scheme, exactly as `SwetLoading` names it.
                            color = colors.accent,
                            strokeWidth = Sizes.borderHairline * 2,
                        )
                    } else {
                        SwetIcon(
                            icon = SwetIcons.Refresh,
                            tint = tint,
                            contentDescription = null,
                            size = Sizes.iconMedium,
                        )
                    }
                }
            }

            // The ⓘ, which opens the peer's public profile. Drawn only when there IS one: a group
            // has no single person behind it, and a conversation that has not loaded cannot name
            // anybody yet. It shares `chat_open_profile` with the identity block above rather than
            // adding a second sentence for the same destination.
            if (peerUsername != null) {
                SwetIconButton(
                    contentDescription = openProfileLabel,
                    onClick = { onOpenProfile(peerUsername) },
                ) { tint ->
                    SwetIcon(
                        icon = SwetIcons.Info,
                        tint = tint,
                        contentDescription = null,
                        size = Sizes.iconMedium,
                    )
                }
            }
        }

        // The one separator on the screen. §12.4's timeline has none, and the mockup has none
        // between anything else either.
        HorizontalDivider(thickness = Sizes.borderHairline, color = colors.border)
    }
}

/**
 * 56dp, which is [SwetTopAppBar]'s own height written the same way it writes it.
 *
 * Restated rather than imported because the design system keeps it private, and a header that
 * silently disagreed with every other bar in the app by a few dp is the kind of thing nobody
 * notices until two screens are side by side.
 */
private val ChatHeaderHeight: Dp = TouchTarget.recommended + Space.one

// THE ⓘ AND THE REFRESH MARK WERE TWO PRIVATE `Canvas` COMPOSABLES HERE, and both said in their own
// KDoc that they belonged in the shared set and were only local because `ui/design/SwetChrome.kt`
// was not that change's to edit. `ui/design/SwetIcons.kt` is that set now, so they are
// `SwetIcons.Info` and `SwetIcons.Refresh` and the header draws them through `SwetIcon` like every
// other mark in the app -- at the set's one stroke width instead of at their own `w * 0.09f`, which
// is the whole reason a ratio-stroked glyph never matched what sat beside it.

/**
 * Attach an image: the mockup's "+" on a dark disc.
 *
 * IT IS STILL THE IMAGE PICKER. The glyph changed and the wiring did not -- it raises the same
 * `onAttachImage` the photo glyph did, so it opens the same chooser and nothing else. The "+" is
 * what the mockup draws and it is honest here for the ordinary reason: this build has exactly one
 * kind of attachment, so a plus and a photo frame lead to the same place, and the CONTENT
 * DESCRIPTION still says "Attach an image" rather than "Add", which is what a screen reader and a
 * switch user actually get told.
 *
 * FILLED, unlike before. It used to be transparent so the accent stayed the send button's alone,
 * and it still does: the disc is `card`, the same grey as the pill beside it, and the only accent
 * in the composer is the send disc. Drawn from primitives for the reason given in `ui/TabIcons.kt`.
 */
@Composable
private fun AttachButton(
    enabled: Boolean,
    onClick: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors
    // Resolved HERE rather than passed in. It used to be a parameter defaulting to a literal, which
    // is a second place the label could be spelled and the place it was spelled in English. Nothing
    // ever overrode it, so the parameter bought nothing and cost the one thing this pass is about.
    // Read before `semantics`, which is not composable and cannot reach a resource from inside.
    val description = stringResource(Res.string.chat_attach_image)
    val tint = if (enabled) colors.textPrimary else colors.textTertiary

    Box(
        modifier = Modifier
            .size(TouchTarget.recommended)
            .clip(CircleShape)
            .background(colors.card)
            // Scale rather than a state layer: this is a button-shaped target, and §25.1's
            // "visible but subtle" press on a 44dp circle is the press itself, not a tint.
            .swetPressable(
                enabled = enabled,
                feedback = SwetPressFeedback.Scale,
                onClick = onClick,
            )
            .semantics { this.contentDescription = description },
        contentAlignment = Alignment.Center,
    ) {
        // The set's own plus. It WAS two `drawLine` calls at 0.24 and 0.76 of the box with a
        // `w * 0.09f` stroke -- the last hand-drawn mark in this file, and the reason it survived
        // the sweep is that it never had a `SwetGlyph` name to grep for.
        SwetIcon(
            icon = SwetIcons.Plus,
            tint = tint,
            contentDescription = null,
            size = Sizes.iconMedium,
        )
    }
}

// THE ACCENT SEND DISC USED TO BE A PRIVATE `SendButton` HERE, and it is `SwetSendButton` in
// `ui/design/SwetComponents.kt` now. The comments sheet grew a composer with the same disc and the
// same three lines at the same seven fractions, copied -- two accent discs meaning "this sends what
// I just wrote", on two surfaces, with nothing to report them drifting apart.
//
// THIS COMPOSER STILL DRAWS IT ONLY WHEN THERE IS SOMETHING TO SEND, so "enabled" and "present"
// remain the same fact here and the shared component's `enabled` is left at its default. The
// comment composer keeps its disc in place and greys it, for a layout reason of its own; both
// behaviours are the caller's.
